
/* ── BB SAMPLES (2026-08-11) ──────────────────────────────────────────────────
   Samples sit in their own free delivery profile, so they must not count toward
   the freight rate, the $500 order minimum, or the lead-time ETA. Identify a
   sample line by the hidden property the PDP button stamps on it, with a variant
   -id fallback, then subtract those lines before any freight maths runs. */
function bbIsSampleLine(it){
  if (!it) return false;
  var p = it.properties || {};
  if (p._src_handle || p['Sample of']) return true;
  return String(it.variant_id) === '48060808298715' || String(it.variant_id) === '50913267450157';
}
function bbFreightCents(cart){
  var t = (cart && cart.total_price) || 0;
  var items = (cart && cart.items) || [];
  for (var i = 0; i < items.length; i++){
    if (bbIsSampleLine(items[i])){
      var lp = (items[i].final_line_price != null) ? items[i].final_line_price : items[i].line_price;
      t -= (lp || 0);
    }
  }
  try { window.__bbSampleCents = ((cart && cart.total_price) || 0) - Math.max(0, t); } catch(_e){}
  return Math.max(0, t);
}
function bbSampleOnly(cart){
  var items = (cart && cart.items) || [];
  if (!items.length) return false;
  for (var i = 0; i < items.length; i++){ if (!bbIsSampleLine(items[i])) return false; }
  return true;
}
/* Sample-only cart: the freight card has nothing true to say, so replace it. */
function bbApplySampleOnly(cart){
  try {
    var only = bbSampleOnly(cart);
    document.documentElement.classList.toggle('bb-sample-only-cart', only);
    var cards = document.querySelectorAll('[id^="bb-ship-"]');
    for (var i = 0; i < cards.length; i++){
      var el = cards[i];
      if (!only){
        if (el.dataset.bbSampleSwapped === '1'){ el.innerHTML = el.dataset.bbSampleOrig || ''; el.dataset.bbSampleSwapped = '0'; }
        continue;
      }
      if (el.dataset.bbSampleSwapped === '1') continue;
      el.dataset.bbSampleOrig = el.innerHTML;
      el.dataset.bbSampleSwapped = '1';
      el.innerHTML = '<div style="border:1px solid #EB673C;border-radius:10px;padding:14px 16px;text-align:center;line-height:1.45">'
        + '<div style="font-weight:800;letter-spacing:.04em">YOUR SAMPLE SHIPS FREE</div>'
        + '<div style="opacity:.75;font-size:14px;margin-top:2px">12&quot; x 12&quot; piece &middot; no order minimum</div>'
        + '<div style="margin-top:6px;font-weight:700">$50 credited back to your account when it ships</div>'
        + '</div>';
    }
  } catch (_e) {}
}

/**
 * BarrierBoss Shipping Estimator — Canada Store (Gamified)
 * Progress bars, tier unlocks, celebration states
 * Fires GA4 custom events for conversion tracking (no Shopify Plus required)
 */
(function() {
  // Canadian provinces → zone mapping
  // QUICK SHIP CONTIGUOUS EXPANSION 2026-08-12 — the single eastern zone 4 is SPLIT to mirror
  // the live checkout profile "Loose Truck — Contiguous" (CA 128724107565), which prices Ontario,
  // Quebec and the Maritimes differently by distance from the BC hub.
  // 1 BC · 2 Alberta · 3 Prairie (west, unchanged) | 4 Ontario · 5 Quebec · 6 Maritimes (NEW)
  // ⛔ YT / NT / NU / NL are absent on purpose — no rate means no checkout, which is correct.
    // ⭐⭐ THE STANDARD CARD, live 2026-10-21. ONLY the kept regions appear here. A region with
  //    no entry has no zone, no rate and no quote — which is the point: checkout refuses it too.
  //    The four zones remain because each 2027 hub will get its OWN four measured from itself;
  //    today they all carry the same price.
  // ⛔ Never add a paused region here without also adding it to the live delivery profiles.
  var ZONES = {
    'BC':1,
    'AB':2,
    'SK':3,'MB':3,
    'ON':4,
    'QC':4,'NB':4,'NS':4,'PE':4
  }

  // ⭐⭐ LANE-AWARE PAUSE 2026-08-12. This used to pause ON/QC/NB/NS/PE outright. Loose Truck now
  // REACHES all of them, so a blanket pause would tell the shopper we don't deliver while the
  // cart charges them $299–$449. It is now CRANE-ONLY: the crane truck still runs the West.
    /* ⭐⭐ REPOPULATED 2026-10-21. THE WARNING THAT USED TO SIT HERE IS NOW REVERSED.
     It read: "Checkout quotes Crane Truck to every one of these states, so any entry here
     makes the storefront contradict the cart. Do NOT repopulate."
     That was true until 2026-10-21. On that date every region below was removed from every zone
     of every delivery profile, so CHECKOUT NOW QUOTES NOTHING for them. An entry here is what
     makes the storefront AGREE with the cart. Left in place, the old note would have stopped the
     next reader doing the correct thing — the header, the PDP chip and the delivery box were all
     quoting "$349 Flat" to New York while the cart refused the order.
     ⛔ The rule that still holds: this list and the live profiles must match. Change both or
        neither. Never-served regions stay in UNSERVED_STATES, which renders a dateless message. */
  var CRANE_PAUSED_PROVINCES = {
    'QC':1,
    'NB':1,
    'NS':1,
    'PE':1
  }
  // Genuinely unserved — these keep the old paused notice.
  var UNSERVED_PROVINCES = { 'YT':1, 'NT':1, 'NU':1, 'NL':1 };   // NL restored 2026-09-17: owner "we cant ship either to new foundland"
  /* PAUSED 2026-10-21. These stay IN ZONES so geoZone is never null — removing them made
     renderElement bail on its first line and the estimator block VANISHED on a paused ZIP.
     Folded into UNSERVED_PROVINCES so the existing notice branch renders them; only its copy differs. */
  /* ONTARIO PAUSED 2026-10-21: 1,893 mi from Kelowna for 41 orders; the loop drops 3,786 -> 1,987 mi.
     Reopen from an EASTERN origin (Toronto is ~300 mi from Pennsylvania), never from this run. */
  /* ⭐⭐ CANADIAN HUB SCHEDULE, from the CA store's OWN /pages/new-facilities:
     Q3 2027 Alberta (AB · SK · western MB · eastern BC) and Q1 2028 ONTARIO, which serves
     Ontario, Quebec AND the Maritimes. ⛔ The USA page lists WA/AZ/GA/PA only — reading it for
     Canadian dates is how the date got stripped from this copy on 2026-10-21. */
  var CA_RESUME_INFO = { 'ON':['Q1 2028','Ontario'], 'QC':['Q1 2028','Ontario'],
                         'NB':['Q1 2028','Ontario'], 'NS':['Q1 2028','Ontario'], 'PE':['Q1 2028','Ontario'] };
  try { window.BB_RESUME_INFO = CA_RESUME_INFO; } catch (_ce) {}
  var PAUSED_REGIONS = { 'ON':1, 'QC':1, 'NB':1, 'NS':1, 'PE':1 };
  for (var _prK in PAUSED_REGIONS) { if (Object.prototype.hasOwnProperty.call(PAUSED_REGIONS, _prK)) UNSERVED_PROVINCES[_prK] = 1; }
  try {
    window.BB_PAUSED_REGIONS = PAUSED_REGIONS;
    /* ⛔ The banner reads BB_PAUSED_STATES / BB_PAUSED_PROVINCES and falls back only when they
       are FALSY. The old assignment handed it an EMPTY object, which is truthy, so the bar
       could never show a pause. Publish the real set under both names. */
    window.BB_PAUSED_STATES = PAUSED_REGIONS;
    window.BB_PAUSED_PROVINCES = PAUSED_REGIONS;
  } catch (_pe) {}
  // Back-compat for legacy readers (banner/PDP): now means "paused for the CRANE lane".
  var PAUSED_PROVINCES = CRANE_PAUSED_PROVINCES;
  var PAUSE_CTA_URL = '/pages/new-facilities#reserve'; // lands on the non-binding waitlist form
  // The published /pages/new-facilities page lists the Ontario hub as Q1 2028,
  // serving ON/QC/Atlantic/SK/eastern MB. Keep this copy in sync with the page
  // if the published date moves.
  try { /* ⛔ removed: re-published the EMPTY set over the real one */ } catch (e) {}

    // ⭐ Distance-based names, not geographic: when the AZ/GA/PA hubs open, each gets its own
  //    four zones measured from itself, so "Zone 2 — Near" stays true from any origin.
  var ZONE_NAMES = {
    1: 'Zone 1 — Home',
    2: 'Zone 2 — Near',
    3: 'Zone 3 — Far',
    4: 'Zone 4 — Furthest'
  }
  // Zones opened by the contiguous expansion; crane does NOT reach them.
  var CRANE_SERVED = { 1:1, 2:1, 3:1, 4:1 };   // crane reaches all four kept zones
  // ⛔ EMPTY since 2026-10-21: this flagged far zones as "extended lead time", which now
  //    contradicts the flat published window. Do not repopulate without changing ZONE_ETA too.
  var QS_NEW_ZONES = {};
  function bbCraneServed(z){ return !!CRANE_SERVED[z]; }

  // ⭐ INVARIANT (owner 2026-08-13): "if we serve both quick and crane, that's our standard zone."
  // Lead time is therefore DERIVED from crane coverage, never maintained as a second list — two
  // hand-kept tables are what showed Ontario 4-6 weeks and BC/AB "1-2 weeks" (faster than real).
  // Standard = Loose Truck 2-4 wks (crane itself is 6-8). Extended = Loose Truck 6-8, no crane.
  // ⭐ TWO TIERS, derived from crane coverage — never a second hand-kept list.
  //   EXPRESS  = crane-served: Loose Truck 2-4 wks, Crane 6-8 wks
  //   EXTENDED = not crane-served: Loose Truck 6-8 wks, no crane (crane there would be ~3 months)
  // A distance-based express tier was tested and dropped: the closest zones actually fulfil
  // SLOWER than the farther ones (75d medians: WA/OR 38d, BC 31d vs Rockies/Southwest 19d), so
  // km does not predict lead time and a 1-2 week promise would have missed ~80% of the time.
  /* ⛔ NO-OP: this runs BEFORE `var ZONE_QS_ETA` (declared below) is initialised, so the
     write throws and the try/catch swallows it. The table BELOW is the live source of truth.
     Do not "restore" this function without moving it AFTER the declaration. */
  /* ⛔ HEAVY-lane zone ETA. Declared here, filled by bbApplyLeadTimes below. NOT named
     ZONE_ETA — a dead local of that name lives inside getShipDates(). */
  var ZONE_ETA_C = {};
  (function bbApplyLeadTimes(){
    /* ⛔ 2026-08-16: lead time is NO LONGER derived from crane coverage. That rule assumed
       crane == the West; once crane opened to the contiguous territory every zone read as
       "express" and the storefront promised extended customers 2-4 weeks instead of the real
       figure. Lead time is now an EXPLICIT per-zone table — do not reintroduce a derivation. */
    try {
      var _L = {"1":[10,30],"2":[10,30],"3":[10,30],"4":[10,30]};   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
      for (var z in _L) if (Object.prototype.hasOwnProperty.call(_L, z)) ZONE_QS_ETA[z] = _L[z];
      /* ⭐ 2026-10-16 HEAVY lane table, BUILT (Canada had none). assembled + loose-heavy run a
         full step behind loose-light in every zone, which is what 331 fulfilled CA orders show
         (light 4.6w vs heavy 8.4w at the median). Kept in its own object so the two lanes can
         never be edited into agreeing again by accident. */
      var _C = {"1":[10,30],"2":[10,30],"3":[10,30],"4":[10,30]};   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
      for (var k in _C) if (Object.prototype.hasOwnProperty.call(_C, k)) ZONE_ETA_C[k] = _C[k];
    } catch (e) {}
  })();
  function bbIsNewZone(z){ return !!QS_NEW_ZONES[z]; }
  // Loose Truck lead time per zone, days [min,max] — owner 2026-08-12, farthest is 6-8 weeks.
  // West 2-4 wk (unchanged) · Ontario 4-6 · Quebec 5-7 · Maritimes 6-8.
  // STANDARD 2-4 wks = BC + Alberta only. EXTENDED 6-8 wks = everything else (owner 2026-08-13:
  // "the standard regions are AB/BC and the 13 states, everything else is extended at 6-8 weeks").
  // SK/MB (zone 3) follow the AB/BC setup — standard 2-4 wks (owner 2026-08-13). Standard =
  var ZONE_QS_ETA = { 1: [10,30], 2: [10,30], 3: [10,30], 4: [10,30] };   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */

  // Production + transit by zone (days)
  // Zone 1 (BC): 2 wk prod + 1-2 days transit = ~2.5 wk
  // Zone 2 (AB): 2 wk prod + 3-5 days transit = ~3 wk
  // Zone 3 (SK): 2 wk prod + 5-8 days transit = ~3.5 wk
  // Zone 4 (East): 2 wk prod + 38-42 days transit = ~8 wk
  var ZONE_PRODUCTION = { 1: 21, 2: 21, 3: 21, 4: 21 };
  var ZONE_TRANSIT_MIN = { 1: 1, 2: 1, 3: 14, 4: 21, 5: 21, 6: 21 };
  var ZONE_TRANSIT_MAX = { 1: 7, 2: 14, 3: 21, 4: 35, 5: 35, 6: 35 };

  // Rates in CAD cents. Edit a ladder here and the PDP estimator, slide-cart and header
  // banner all follow.
  // FOUR DISTANCE BANDS, live 2026-10-05. ONE rate per zone, every cart value — the seven
  // elements of a ladder are deliberately identical, and NONE of them is 0.
  // ⭐⭐ STEPPED LADDER, live 2026-10-26: $149/$199 -> $49/$99 -> FREE at $3,500. The 0 bands
  //    are INTENTIONAL and mirror checkout. ⛔ The old "there is no free tier, never use a 0"
  //    rule belonged to the retired flat card — do NOT restore it. There is still no order
  //    minimum. ⚠️ FREE must never render in a PAUSED region; the zone gate handles that.
  // ⛔ The seven bands exist only because the ladder shape is shared with the banner, the
  //    configurator and the freight finder. Flatten a ladder by setting all seven, never by
  //    shortening it.
  // ⛔ ORDER MINIMUMS, live 2026-10-16 (owner). Z1 $250 · Z2 $500 · Z3 $750 · Z4 $1000.
  //    A minimum is the ABSENCE OF A RATE: below it checkout quotes nothing and the cart
  //    cannot complete. It is NOT a surcharge.
  // ⭐ DERIVED FROM THE ZONE'S OWN RATE, never a second zone list — the rate IS the distance
  //    band, so a reprice moves the minimum with it. Mirrors the live checkout floors.
  // ⛔ Bands are clamped UP to the floor: getCurrentTierIndex scans top-down and returns the
  //    first tier the cart clears, so a band below the floor would quote under the minimum.
  // ⛔⛔ THERE IS NO ORDER MINIMUM. All 16 TOTAL_PRICE conditions were DELETED from both
  //    stores' delivery profiles on 2026-10-21 (owner). A sub-$250 cart now quotes and completes
  //    at the full flat rate. Keep these 0 — a non-zero value re-creates a floor the cart no
  //    longer has, and the storefront would refuse an order checkout accepts.
  /* ⭐ $500 ORDER MINIMUM, live 2026-10-26. This map sets the FIRST band's min, so a non-zero
     value here is what makes _dpMin real and re-enables the _belowMin branch everywhere. */
  var _BB_MIN_FOR_RATE = { 99: 50000, 49: 50000, 149: 50000, 199: 50000, 249: 50000, 299: 50000, 349: 50000, 399: 50000, 449: 50000, 499: 50000 };
  var _BB_BANDS = [50000, 200000, 500000, 500000, 1000000, 1500000, 2500000]; // cents
  /* ⛔⛔ THE TWO LANES STEP AT DIFFERENT CART VALUES — Light at $1,000, HEAVY at $1,500 — and one
     shared band array cannot express that. Using _BB_BANDS for CRANE_RATES quoted $99 from $1,000
     while checkout still billed $199 until $1,500, so the storefront UNDER-quoted every heavy cart
     in that range. Heavy gets its own bands; _bbLH is _bbL against them. */
  /* ⛔ Both lanes step at $2,500 under the approved card, so these now MATCH _BB_BANDS. They
     diverged earlier today and that divergence quoted heavy $99 from $1,000 while checkout billed
     $199 to $1,499. Kept as its own array so a future lane split has somewhere to go. */
  var _BB_BANDS_HEAVY = [50000, 200000, 500000, 500000, 1000000, 1500000, 2500000]; // cents
  // ⭐ index 2 is $3,500 — the live FREE threshold. _bbL maps index 0 to $0 via
  //    _BB_MIN_FOR_RATE, so the effective bands are [0, 1k, 3.5k, 5k, 10k, 15k, 25k].
  function _bbL(d){
    var _m0 = _BB_MIN_FOR_RATE[d[0]];
    if (_m0 == null) _m0 = _BB_BANDS[0];   // unknown rate -> the old $500 floor, never 0
    return d.map(function (v, i) {
      return { min: (i === 0 ? _m0 : Math.max(_m0, _BB_BANDS[i])), rate: v * 100, label: v === 0 ? 'FREE' : 'C$' + v }; /* CA CURRENCY 2026-11-01: this label is PUBLISHED to BB_SHIP_RATES and every downstream surface derives its currency from it. */
    });
  }
  function _bbLH(d){
    var _m0 = _BB_MIN_FOR_RATE[d[0]];
    if (_m0 == null) _m0 = _BB_BANDS_HEAVY[0];
    return d.map(function (v, i) {
      return { min: (i === 0 ? _m0 : Math.max(_m0, _BB_BANDS_HEAVY[i])), rate: v * 100, label: v === 0 ? 'FREE' : 'C$' + v }; /* CA CURRENCY 2026-11-01 */
    });
  }
  // Mirrors the live CA checkout profile "Loose Truck — Contiguous" (128724107565).
    // ⭐⭐ ONE STANDARD RATE: $149 Light in EVERY zone, live 2026-10-21. Owner: "one standardized
  //    zone feel" — these rates already work in the close regions, so applying them to the
  //    furthest grows volume there and fills the loop. DENSITY is the only lever that moves cost
  //    per stop hard: 118 stops/mo = $151/stop, double it = $76, triple it = $50.
  // ⛔ NOT the retired flat-$149 card — there is NO free-over-$5,000 tier and NO order minimum.
  // ⭐⭐ STEPPED LADDER, live 2026-10-26. The zero bands are INTENTIONAL and mirror the
  //    live checkout tiers — bb-mobile-atc.js SHOULD render its "FREE" row above $3,500.
  //    ⛔ The old "NONE is 0" rule was for the flat card and is now wrong; do not restore it.
  //    ⚠️ FREE must still never appear in a PAUSED region — the zone gate handles that.
  var RATES = {
    1: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    2: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    3: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    4: _bbL([ 149, 0, 0, 0, 0, 0, 0 ])
  }

  // CRANE freight ladder (added 2026-07-27) — mirrors the live Crane delivery profile.
  // ⛔ Crane now serves the FULL contiguous territory (opened 2026-08-16).
// Extended zones carry their own ladder below — do NOT reinstate a West-only guard.
    // ⭐⭐ ONE STANDARD RATE: $199 Heavy/crane in EVERY zone, live 2026-10-21.
  var CRANE_RATES = {
    1: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    2: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    3: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    4: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ])
  }
  function bbCartHasCrane(items){
    if(!items||!items.length) return false;
    var looseLight=/unframed|just the (metal|wire)|loose sheets?|no frame/i;
    var craneSig=/ready to install|pressure treated|\bcedar\b|full metal|\bgate|zero[\s-]?maintenance|\bzm\b|\bkit\b|assembled|\bpost|corten/i;
    for(var i=0;i<items.length;i++){
      var it=items[i]||{}, t=(it.variant_title||'')+' | '+(it.title||'')+' | '+(it.product_title||'')+' | '+(it.handle||'');
      var ov=it.options_with_values; if(ov&&ov.length){for(var k=0;k<ov.length;k++){t+=' | '+((ov[k]&&ov[k].value)||'');}}
      if(looseLight.test(t)) continue;
      if(craneSig.test(t)) return true;
    }
    return false;
  }
  // Which LANES the cart spans. bbCartHasCrane() answered a yes/no question and so could never
  // describe the cart that costs the most: one that spans both. Same positive-signal matching as
  // before (an item matching neither pattern votes for nothing), so a pure-unframed cart still
  // reads loose and nothing that used to be crane stops being crane.
  function bbCartLanes(items){
    /* ⭐ TRUTH FIRST. cart-items.liquid publishes this from the custom.shipping_mode metafield —
       the same field profile membership (and therefore the bill) is derived from. The title
       regex below is a FALLBACK for pages where that snippet has not rendered; it misses any
       heavy item whose name lacks a crane keyword, which quoted a mixed cart as pure Light. */
    try {
      var _truth = window.__bbCartLanesTruth;
      if (_truth && typeof _truth.loose === 'boolean' && typeof _truth.crane === 'boolean') {
        return { loose: _truth.loose, crane: _truth.crane };
      }
    } catch (_e) {}
    var lanes = { loose:false, crane:false };
    if(!items||!items.length) return lanes;
    var looseLight=/unframed|just the (metal|wire)|loose sheets?|no frame/i;
    var craneSig=/ready to install|pressure treated|\bcedar\b|full metal|\bgate|zero[\s-]?maintenance|\bzm\b|\bkit\b|assembled|\bpost|corten/i;
    for(var i=0;i<items.length;i++){
      var it=items[i]||{}, t=(it.variant_title||'')+' | '+(it.title||'')+' | '+(it.product_title||'')+' | '+(it.handle||'');
      var ov=it.options_with_values; if(ov&&ov.length){for(var k=0;k<ov.length;k++){t+=' | '+((ov[k]&&ov[k].value)||'');}}
      if(looseLight.test(t)){ lanes.loose=true; continue; }
      if(craneSig.test(t)){ lanes.crane=true; }
    }
    return lanes;
  }
  /* ⭐ CART LINE ETA — fills the empty [data-bb-lane] spans that cart-items.liquid renders.
     Uses getShipDates with the lane forced, so a cart line can never show a date the card
     disagrees with. The write is skipped when the text already matches, so the observer below
     cannot retrigger itself. */
  /* ⭐ MIXED NOTICE — fills rate / ETA / saving from the SAME tables everything else reads.
     Empty, never guessed, when the zone is unknown. */
  function bbFillMixNote(){
    try{
      var _r = document.querySelector('[data-bb-mixnote]'); if(!_r) return;
      var _st = null; try { _st = sessionStorage.getItem('bb_geo_state'); } catch(e){}
      var _z = (window.BB_ZONES||{})[_st];
      var _L = (window.BB_SHIP_RATES||{})[_z], _H = (window.BB_CRANE_RATES||{})[_z];
      /* ⭐ UNKNOWN ZONE — DERIVE, NEVER GUESS. A visitor whose region does not resolve (measured:
         bb_geo_state = "UT" on the CA store, which has no such key in BB_ZONES) used to leave every
         figure blank, printing "you save at least ," at the customer. If EVERY zone in the map
         carries an identical ladder then the rate does not depend on the zone at all, so quoting
         it is a fact rather than an assumption. If any zone differs, this yields null and the
         clause below is hidden instead — self-disabling, with no constant to keep in sync. */
      if(!_L || !_H || !_L.length || !_H.length){
        var _consensus = function(map){
          try{
            var ks = Object.keys(map || {});
            if(!ks.length) return null;
            var first = JSON.stringify(map[ks[0]]);
            for(var i=1;i<ks.length;i++) if(JSON.stringify(map[ks[i]]) !== first) return null;
            return map[ks[0]];
          }catch(e){ return null; }
        };
        _L = _consensus(window.BB_SHIP_RATES);
        _H = _consensus(window.BB_CRANE_RATES);
      }
      /* ⛔ A FAILURE MUST NOT READ LIKE A SENTENCE WITH A HOLE IN IT. The two-truck warning is true
         whatever the geo, so the box stays — but the saving clause is removed when there is no
         figure to put in it, rather than rendering a dangling comma. */
      var _clause = _r.querySelector('[data-bb-mix="saveclause"]');
      if(!_L || !_H || !_L.length || !_H.length){
        if(_clause) _clause.style.display = 'none';
        return;
      }
      if(_clause) _clause.style.display = '';
      /* ⭐ THE BAND THAT MATCHES THIS LANE'S OWN SUBTOTAL, not the first band. _L[0].rate always
         printed the full rate, so the notice said $149/$199 on every cart — including a $6,000
         order that checkout delivers free. Values come from __bbCartLaneValues (cents). */
      var _lv = ((window.__bbCartLaneValues||{}).light)|0, _hv = ((window.__bbCartLaneValues||{}).heavy)|0;
      var _pick = function(tiers, cents){
        var r = tiers[0].rate;
        for (var i = 0; i < tiers.length; i++) if (cents >= tiers[i].min) r = tiers[i].rate;
        return r;
      };
      var _lr = _pick(_L, _lv), _hr = _pick(_H, _hv);
      var _set = function(k, val){
        var e = _r.querySelector('[data-bb-mix="' + k + '"]');
        if (e && val && e.textContent !== val) e.textContent = val;
      };
      _set('light-rate', money(_lr));
      _set('heavy-rate', money(_hr));
      _set('save', money(Math.min(_lr, _hr)));
      /* ⛔⛔ NO ZONE MEANS NO DATES — BUT THE RATES STILL STAND. getShipDates() with no zone
         returns ONE generic window, so both lanes printed the same span (measured: "Dec 7 – Dec
         28" for Light AND Heavy) directly above "Light is the quicker of the two". The rate is
         zone-independent and consensus-checked above, so it survives; the date is not, so it goes.
         ⛔ CLEARED, not just skipped: _set ignores empty values, so dates from an earlier render
            with a good zone would otherwise linger after a geo change and read as current. */
      var _etaZoneKnown = !!((window.BB_SHIP_RATES || {})[_z]);
      if (_etaZoneKnown) {
        try { var _dl = getShipDates(null,'q'); _set('light-eta', (_dl && (_dl.range || _dl.arrive)) || ''); } catch(e){}
        try { var _dh = getShipDates(null,'c'); _set('heavy-eta', (_dh && (_dh.range || _dh.arrive)) || ''); } catch(e){}
      } else {
        try {
          var _etaEls = _r.querySelectorAll('[data-bb-mix="light-eta"],[data-bb-mix="heavy-eta"]');
          for (var _etaI = 0; _etaI < _etaEls.length; _etaI++) _etaEls[_etaI].textContent = '';
        } catch(e){}
      }
    }catch(e){}
  }
  try{
    bbFillMixNote();
    document.addEventListener('DOMContentLoaded', bbFillMixNote);
    /* ⛔⛔ THE 150ms DEBOUNCE BELOW USED TO NEVER FIRE. Measured on the live cart page: 46 mutation
       records in 3s, and an identical debounce on this same observer fired 0 times in 6 seconds.
       Every mutation cancelled the pending call, so this function only ever ran at the two call
       sites above — both of which happen BEFORE the geo lookup resolves, where it takes its
       early return. The note sat blank with no error to find, because the catch is empty.
       ⭐ The real fix is the event subscriptions: bb:geo-change is the exact moment the zone
          arrives and the early return stops applying. */
    var _mixFill = function(){ try{ bbFillMixNote(); }catch(e){} };
    var _mixEv = ['bb:geo-change','bb:cart-lanes','bb:so-state','bb:calc-quote','bb:cart-updated'];
    for (var _mi = 0; _mi < _mixEv.length; _mi++) document.addEventListener(_mixEv[_mi], _mixFill);
    /* ⭐ bounded ladder for a geo resolution that lands without dispatching anything we hear;
       it stops as soon as the note carries a figure, so it cannot poll forever. */
    var _mixTries = [400, 1200, 2500, 5000];
    for (var _mt = 0; _mt < _mixTries.length; _mt++) {
      setTimeout(function(){
        try {
          var _n = document.querySelector('[data-bb-mixnote] [data-bb-mix="light-rate"]');
          if (_n && _n.textContent) return;    /* already filled — nothing to do */
        } catch(e){}
        _mixFill();
      }, _mixTries[_mt]);
    }
    /* ⭐ MAX WAIT: the debounce still coalesces bursts, but can no longer be starved — once a
       mutation is pending it fires within 600ms whatever else the page is doing. */
    var _mixFirst = 0;
    var _bbMixObs = new MutationObserver(function(){
      var _now = Date.now();
      if (!_mixFirst) _mixFirst = _now;
      if (_now - _mixFirst >= 600) { clearTimeout(window.__bbMixT); _mixFirst = 0; _mixFill(); return; }
      clearTimeout(window.__bbMixT);
      window.__bbMixT = setTimeout(function(){ _mixFirst = 0; _mixFill(); }, 150);
    });
    _bbMixObs.observe(document.documentElement, { childList:true, subtree:true });
  }catch(e){}
  /* ⛔⛔ THE LANE STATE MUST SURVIVE AN AJAX CART RE-RENDER — THIS WAS A LIVE MISPRICING.
     cart-items.liquid publishes __bbCartLanesTruth from an INLINE <script>, and a <script> swapped
     in with the re-rendered cart markup NEVER EXECUTES. The object froze at the composition the
     page was PARSED with, and bbCartLanes() below short-circuits to it and discards the cart it
     just fetched — so the delivery row priced a pure-Heavy cart as Mixed ($348 for $199 of
     freight), the ETA kept the mixed span, and the announcement bar never heard 'bb:cart-lanes'
     because that same dead script is what dispatches it.
     ⭐ The CHIPS are markup, so they are fresh after every re-render. data-bb-lane-mode carries the
        snippet's own bb_lane, computed from the custom.shipping_mode METAFIELD — so this is a
        re-read of the existing truth, never a second classification. */
  function bbLanesFromCartDom(){
    try{
      var els = document.querySelectorAll('[data-bb-lane-mode]');
      if(!els.length) return null;          /* no cart markup here — never clobber the inline value */
      var loose=false, crane=false;
      for(var i=0;i<els.length;i++){
        var m = els[i].getAttribute('data-bb-lane-mode');
        if(m === 'c') crane = true;
        else if(m === 'q') loose = true;    /* '' = ships free: rides along, votes for NEITHER lane */
      }
      return { loose: loose, crane: crane };
    }catch(e){ return null; }
  }
  function bbRepublishLanes(){
    try{
      var d = bbLanesFromCartDom();
      if(!d) return;
      var t = window.__bbCartLanesTruth;
      /* ⛔ republish only on a REAL change: the banner's refresh() mutates the DOM, which re-fires
         the observer that called this, which would otherwise loop forever. */
      if(t && t.loose === d.loose && t.crane === d.crane) return;
      window.__bbCartLanesTruth = d;
      window.__bbCartLanes = d;
      try{ document.dispatchEvent(new CustomEvent('bb:cart-lanes')); }catch(e){}
      /* ⛔⛔ THE EVENT ALONE ONLY MOVES THE ANNOUNCEMENT BAR — it is the one listener. The delivery
         card on the PDP and in the drawer is painted by renderAll(), and this file subscribes to
         bb:so-state, bb:calc-quote and bb:geo-change but NEVER to a lane change. Without this the
         lane is correct in window and stale on screen, and only a hard refresh fixes it (owner
         2026-10-17: "pdp doesn't update on any of this logic without a hard refresh").
         ⭐ bbReeval() re-reads /cart.js and re-renders every surface this file owns; it is already
         debounced. ⛔ The re-render re-fires the observer that called us — harmless ONLY because
         the guard above returns early once the derived lanes match. Do not remove that guard. */
      try{ bbReeval(); }catch(e){}
    }catch(e){}
  }
  function bbFillLaneEtas(){
    try{
      var _n = document.querySelectorAll('[data-bb-lane]');
      if(!_n.length) return;
      var _c = {};
      for(var _i=0;_i<_n.length;_i++){
        var _ln = _n[_i].getAttribute('data-bb-lane');
        if(!(_ln in _c)){
          try{ var _d = getShipDates(null, _ln); _c[_ln] = (_d && (_d.range || _d.arrive)) ? (_d.range || _d.arrive) : ''; }
          catch(e){ _c[_ln] = ''; }
        }
        if(_c[_ln] && _n[_i].textContent !== _c[_ln]) _n[_i].textContent = _c[_ln];
      }
    }catch(e){}
  }
  try{
    bbFillLaneEtas();
    document.addEventListener('DOMContentLoaded', bbFillLaneEtas);
    var _bbLaneObs = new MutationObserver(function(){
      clearTimeout(window.__bbLaneT);
      /* ⭐ lanes FIRST, then the dates that depend on them — same observer, same 120ms debounce */
      window.__bbLaneT = setTimeout(function(){ bbRepublishLanes(); bbFillLaneEtas(); }, 120);
    });
    _bbLaneObs.observe(document.documentElement, { childList:true, subtree:true });
  }catch(e){}
  function bbCartMixedNow(){ try {
    return !!(window.__bbCartLanes && window.__bbCartLanes.loose && window.__bbCartLanes.crane);
  } catch(e){ return false; } }
  // MIXED ladder = quick + crane, band by band. Both profiles read the WHOLE cart total, so the
  // bands line up and the sum is exact rather than an estimate. Built only for zones the crane
  // truck actually reaches — everywhere else a mixed cart has no checkout rate at all and must
  // not be handed a number (see the bb:ship-rate dispatch below).
  var _bbMixedCache = null;
  function bbMixedRates(){
    if(_bbMixedCache) return _bbMixedCache;
    var out = {};
    for(var z in CRANE_RATES){
      if(!CRANE_RATES.hasOwnProperty(z) || !RATES[z]) continue;
      out[z] = CRANE_RATES[z].map(function(t, i){
        /* ⭐ TWO PROFILES AGAIN 2026-10-16 — Shopify bills one rate per profile a cart touches, so a
           mixed cart really is charged both lanes. Restored to the sum this function was built for. */
        /* ⛔ NO LONGER A SUM (2026-11-01). Light and Heavy are ONE profile now, so a cart cannot
           touch two profiles and cannot be billed twice. Summing printed $198 against a $99
           checkout. Kept as a function because three surfaces call it. */
        return { min: t.min, rate: t.rate, label: t.rate === 0 ? 'FREE' : '$' + (t.rate / 100) };
      });
    }
    _bbMixedCache = out;
    return out;
  }
  function bbCraneNow(){ try {
    /* ⭐ ONE OWNER for the lane signal. Publish whatever this returns so the
       announcement bar cannot disagree with the PDP: the bar used to read a
       cart-only flag and showed "from $49" under a $99 crane variant. */
    /* ⛔ OFF-PDP THE LANE IS LOOSE. bbIsUnframedNow() returns false when bbHogWire is unset,
       and bbHogWire only ever comes from #bb-ship-est-product (a PDP-only element). So on the
       homepage/collections/blog the old `!bbIsUnframedNow()` evaluated to TRUE and the bar
       quoted the CRANE entry ($199) where the honest "from" price is loose ($149).
       On a PDP the viewed-variant fallback is kept exactly as it was. */
    var _bbOnPdp = !!document.getElementById('bb-ship-est-product');
    /* ⭐ shipping_mode is the field the PROFILE bills on, so it outranks the framing guess:
       "loose - heavy" is unframed yet bills CRANE. Returns null when the attribute is absent,
       so older pages fall through to the previous behaviour unchanged. */
    var _bbModeLane = (function(){
      try {
        var _el = document.getElementById('bb-ship-est-product');
        if (!_el) return null;
        var _ids = _el.getAttribute('data-bb-crane-ids');
        if (_ids === null) return null;
        var _f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var _id = _f && _f.value;
        if (!_id) return null;
        return (' ' + _ids + ' ').indexOf(' ' + _id + ' ') !== -1;
      } catch (e) { return null; }
    })();
    /* ⭐⭐ THE CART TRUTH OUTRANKS EVERYTHING ELSE. __bbCartCrane* is a SECOND, older cart-lane
       flag and is NOT the one cart-items.liquid publishes, so a pure-Heavy cart could leave
       __bbLaneCrane FALSE — and the delivery row printed "Light Delivery · $149" over a crane-only
       cart while the DATE beside it correctly read the Heavy window (measured live 2026-10-17).
       __bbCartLanesTruth comes from custom.shipping_mode, the field the PROFILE bills on, and is
       refreshed on every cart re-render, so it is the authority whenever the cart holds a lane.
       ⛔ The POLICY is unchanged — the old chain already preferred the cart when it had items and
          fell back to the viewed variant only for an EMPTY cart. Only the source is corrected.
       ⛔ A MIXED cart never reaches here: bbRates() returns the summed ladder from bbCartMixedNow()
          first. */
    var _bbTruth = window.__bbCartLanesTruth;
    var _bbTruthLane = (_bbTruth && (_bbTruth.crane || _bbTruth.loose)) ? !!_bbTruth.crane : null;
    var _bbLane = (_bbTruthLane !== null)
      ? _bbTruthLane
      : ((window.__bbCartCraneKnown && window.__bbCartItemCount>0)
        ? !!window.__bbCartCrane
        : (_bbModeLane !== null ? _bbModeLane
          : (_bbOnPdp ? !bbIsUnframedNow() : false)));
    try { window.__bbLaneCrane = _bbLane; } catch(e){}
    return _bbLane;
  } catch(e){ return false; } }
  // The VIEWED variant counts, not just the cart: a shopper looking at a framed panel with an
  // empty cart is a crane order, and quoting the Loose Truck ladder under-quotes them by $100.
  // Only #bb-ship-est-product exists on a PDP, so cart contexts are unaffected.
  function bbPdpCraneNow(){
    try {
      if (!document.getElementById('bb-ship-est-product')) return false;
      return bbHogWire ? !bbIsUnframedNow() : true;
    } catch (e) { return false; }
  }
  // A mixed cart is charged BOTH profiles, so it must be quoted from both. Verified live:
  // $549.98 mixed cart -> checkout "Shipping = 198.00", not the $149 this used to render.
  function bbRates(){
    if (bbCartMixedNow()) return bbMixedRates();
    if (bbCartMixedNow()) { var _mx = bbMixedRates(); if (_mx && Object.keys(_mx).length) return _mx; }
    return bbCraneNow() ? CRANE_RATES : RATES;   // cart truth only — bbPdpCraneNow() is bbCraneNow()'s own empty-cart fallback, and OR-ing it quoted CRANE for a known LOOSE cart viewed from a crane PDP
  }
  // Publish RATES + ZONES as well, not just CRANE_RATES: the bottom-right FOB
  // (bb-mobile-atc.js) reads these to price by zone, and without them it can't.
  try { window.BB_SHIP_RATES = RATES; window.BB_CRANE_RATES = CRANE_RATES; window.BB_ZONES = ZONES;
    /* Loose Truck contiguous expansion 2026-08-12 — consumers must tell "crane can't reach you"
       apart from "we don't serve you at all". Mirrors the USA estimator's exports. */
    window.BB_CRANE_SERVED = CRANE_SERVED; window.BB_QS_NEW_ZONES = QS_NEW_ZONES;
    /* The header bar needs the SUM for a cart that spans both profiles. Exported as a function so
       there is exactly one implementation of "what does a mixed cart cost" on the page. */
    window.BB_MIXED_RATES_FN = bbMixedRates;
    window.BB_ZONE_QS_ETA = ZONE_QS_ETA; /* ⭐ ONE owner for the holiday table — the PDP accordion reads it instead of carrying a 5th copy. */ window.BB_HOL = _BB_HOL; window.BB_ZONE_ETA = ZONE_ETA_C; /* ⛔ CA built ZONE_ETA_C but never published it, so the banner had no crane window and showed light for every cart. */ window.BB_UNSERVED_STATES = UNSERVED_PROVINCES;
    window.BB_CRANE_PAUSED_STATES = CRANE_PAUSED_PROVINCES; } catch(e){}


  var STATE_NAMES = {
    'BC':'British Columbia','AB':'Alberta','SK':'Saskatchewan',
    'MB':'Manitoba','NB':'New Brunswick','NS':'Nova Scotia',
    'ON':'Ontario','QC':'Quebec','PE':'Prince Edward Island',
    'NL':'Newfoundland','NT':'Northwest Territories','NU':'Nunavut','YT':'Yukon'
  };

  /* The postal-letter map moved to assets/bb-geo.js. Note the deliberate
     behaviour match: this table used to return NL / NT / YT for A / X / Y and
     then rely on the ZONES gate below to reject them. BBGeo returns null for
     those three letters instead, which reaches the same outcome one step
     earlier and cannot be mistaken for a served province by a future caller. */

  var geoState = null;
  var geoCity = null;
  var geoZone = null;
  // ── LOOSE-LIGHT ETA: unframed wire (hog/cattle/deck railing) = Loose Truck 2-4 wks. Read LIVE from DOM. ──
  var bbHogWire=false,bbUnframedInit=false;
  (function(){var el=document.getElementById('bb-ship-est-product');if(el){bbHogWire=el.getAttribute('data-bb-hogwire')==='true';bbUnframedInit=el.getAttribute('data-bb-init-unframed')==='true';}})();
  function bbIsUnframedNow(){
    if(!bbHogWire)return false;
    var fr=/unframed|just the (metal|wire)/i, frm=/pressure treated|cedar|full metal/i;
    var r=document.querySelectorAll('input[type="radio"]:checked');
    for(var i=0;i<r.length;i++){var v=r[i].value||'';if(fr.test(v))return true;if(frm.test(v))return false;}
    var s=document.querySelectorAll('select');
    for(var j=0;j<s.length;j++){if(s[j].selectedIndex<0)continue;var o=s[j].options[s[j].selectedIndex];if(!o)continue;var ov=o.value||o.textContent||'';if(fr.test(ov))return true;if(frm.test(ov))return false;}
    var sel=document.querySelectorAll('[aria-checked="true"],.is-selected,[data-selected="true"]');
    for(var k=0;k<sel.length;k++){var sv=sel[k].value||sel[k].textContent||'';if(fr.test(sv))return true;if(frm.test(sv))return false;}
    return bbUnframedInit;
  }
  var bbFrDeb;
  function bbPublishEta(){try{var d=getShipDates(0);var a=d.range||d.arrive||'';var s=(function(x){var m=(x||'').match(/^([A-Za-z]+) (\d+)\s*[–-]\s*([A-Za-z]+) (\d+)$/);return m?(m[1]===m[3]?m[1]+' '+m[2]+'–'+m[4]:m[1]+' '+m[2]+'–'+m[3]+' '+m[4]):x;})(a);if(s)window.BB_ETA={etaStr:s};}catch(e){}}
  function bbReeval(){clearTimeout(bbFrDeb);bbFrDeb=setTimeout(function(){try{refreshFromCart();}catch(_){}bbPublishEta();},120);}
  try{bbPublishEta();}catch(e){}
  document.addEventListener('DOMContentLoaded',function(){try{bbPublishEta();}catch(e){}});
  document.addEventListener('change',bbReeval,true);
  document.addEventListener('on:variant:change',bbReeval);
  var lastTierIndex = -1;

  function resetGeo() {
    geoState = null;
    geoCity = null;
    geoZone = null;
    lastTierIndex = -1;
    sessionStorage.removeItem('bb_geo_state');
    sessionStorage.removeItem('bb_geo_city');
    sessionStorage.removeItem('bb_geo_city_ok');
    var est;
    est = document.getElementById('bb-ship-est-product');
    if (est) { est.style.display = 'none'; est.removeAttribute('data-rendered'); est.removeAttribute('data-ga4-viewed'); }
    est = document.getElementById('bb-ship-est-cart');
    if (est) { est.style.display = 'none'; est.removeAttribute('data-rendered'); est.removeAttribute('data-ga4-viewed'); }
    showZipFallback();
  }

  // === GA4 EVENT HELPER ===
  function ga4Event(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, params || {});
    }
  }

  function money(cents) {
    return 'C$' + Math.round(cents / 100).toLocaleString('en-CA'); /* CA CURRENCY 2026-11-01: was '$', so a Canadian read a USA symbol on the rate row. */
  }

  // BarrierBucks earn line — appended to the trust strip, renders ONLY when
  // window.BB_BUCKS.enabled (set by bb-discount-config.liquid from
  // shop.metafields.bb_loyalty.config; defaults disabled = zero change).
  // "Up to": the engine awards on the POST-discount subtotal, so this is a ceiling.
  function bbBucksLine(cartTotal) {
    var B = window.BB_BUCKS;
    if (!B || !B.enabled) return ''; /* re-enabled 2026-07-03: BarrierBucks in the estimator */ // 2026-06-10 owner: BarrierBucks shows in the bank-discount bar ONLY — estimator line disabled (re-enable by restoring the B.enabled gate)
    var rate = (typeof B.rate === 'number' && B.rate > 0 && B.rate < 1) ? B.rate : 0.03;
    var cap = (typeof B.cap === 'number' && B.cap > 0) ? B.cap : 500;
    var url = B.url || '/pages/barrierbucks';
    var _bbT = Math.max(0, cartTotal - (window.__bbSampleCents || 0)); /* samples are fully credited — no bucks */
  var amt = (_bbT > 0) ? Math.min(cap, Math.floor((_bbT / 100) * rate)) : 0;
    var msg = (amt >= 1)
      ? 'Earn up to <strong style="color:#EB673C;">$' + amt + ' in BarrierBucks</strong> on this order'
      : 'Earn <strong style="color:#EB673C;">' + Math.round(rate * 100) + '% back in BarrierBucks</strong> on every order';
    return '<div class="bb-bucks-line" style="padding:7px 14px;border-top:1px solid rgba(0,0,0,.06);text-align:center;font-size:11px;line-height:1.4;color:#1a1a1a;">💵 ' + msg + ' — store credit for your next order. <a href="' + url + '" style="color:#EB673C;text-decoration:underline;font-weight:600;">How it works</a></div>';
  }

  var ARRIVE_WINDOW = 4;

  // Special Order detection (added 2026-05-10)
  var hasSpecialOrderInCart = false;
  var SPECIAL_ORDER_PROD_DAYS = 56;
  // Detect Special Order from current PDP variant selection.
  // Returns true if the currently-viewed product/variant is SO.
  function detectSpecialOrderFromPDP() { /*BB_SO_RETIRED 2026-07-19: Special Order discontinued — was forcing a 56-84 day ETA and a SPECIAL ORDER pill on live products. Restore by deleting this return.*/ return false;
    var jsonEl = document.querySelector('script[data-product-json]') || document.querySelector('script[type="application/json"][data-product]');
    if (!jsonEl) return false;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return false; }
    var product = data.product || data;
    if (!product) return false;
    // Whole product SO
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === 'special-order') return true;
    }
    // Find currently selected variant via the option selectors
    var selectedOpts = {};
    var sels = document.querySelectorAll('select.single-option-selector');
    for (var s = 0; s < sels.length; s++) {
      var n = (sels[s].dataset.optionName || '').toLowerCase();
      if (n) selectedOpts[n] = sels[s].value;
    }
    // Variant-level mesh check — match any option name that contains "wire opening" or "mesh"
    var meshVal = null;
    for (var moKey in selectedOpts) {
      if (/wire.?opening|mesh/i.test(moKey)) { meshVal = selectedOpts[moKey]; break; }
    }
    if (meshVal) {
      if (/\b1\s*["'\u2032\u2033\u201c\u201d\u2019]?\s*[x\u00d7]\s*1\b/i.test(meshVal)) return true;
      if (/\b2\s*["'\u2032\u2033\u201c\u201d\u2019]?\s*[x\u00d7]\s*6\b/i.test(meshVal)) return true;
    }
    // Variant-level rules (color/width)
    var origOpts = {};
    for (var origKey in selectedOpts) origOpts[origKey] = selectedOpts[origKey];
    // selectedOpts keys are lowercased — re-key with original casing using selectors
    var sels2 = document.querySelectorAll('select.single-option-selector');
    var keyedOpts = {};
    for (var s = 0; s < sels2.length; s++) {
      var raw = sels2[s].dataset.optionName || sels2[s].name || '';
      if (raw) {
        // Capitalize each word for matching VARIANT_SO_RULES regex
        var capitalized = raw.split(' ').map(function(w){return w.charAt(0).toUpperCase()+w.slice(1)}).join(' ');
        keyedOpts[capitalized] = sels2[s].value;
      }
    }
    if (product.handle && isVariantSOByRules(product.handle, keyedOpts)) return true;
    return false;
  }
  
  // Per-product variant SO rules (color/width-based, beyond universal mesh).
  var VARIANT_SO_RULES = {
    'hog-wire-gates-rigid-black-hog-wire-gauge-6': [
      { optionRegex: /color/i, valueRegex: /corten|rust|patina|green/i },
    ],
    'cattle-panel-gates-rigid-cattle-panel-fence-gate-gauge-6-cattle-panels-w-hinges-hardware': [
      { optionRegex: /color/i, valueRegex: /corten|rust|patina|green/i },
    ],
    'metal-fence-posts-for-wood-fence': [
      { optionRegex: /color/i, valueRegex: /brown/i },
      { optionRegex: /width/i, valueRegex: /5\s*["\u201d]?\s*[x\u00d7]\s*5/i },
    ],
  };
  function isVariantSOByRules(productHandle, selectedOpts) {
    var rules = VARIANT_SO_RULES[productHandle] || [];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      for (var key in selectedOpts) {
        if (!Object.prototype.hasOwnProperty.call(selectedOpts, key)) continue;
        if (r.optionRegex.test(key) && r.valueRegex.test(String(selectedOpts[key] || ''))) return true;
      }
    }
    return false;
  }

  // Whole-product SO handles — /cart.js does not return product_tags, so we match by handle.
  var SO_PRODUCT_HANDLES = {
    'rust-patina-hog-wire-fence-panels-hog-panels-premade-or-unframed-the-red-rock': 1,
    'rust-patina-hog-wire-deck-railing-panels-premade-or-unframed-the-copperhead': 1,
    'rust-cattle-panel-fence-cattle-panels-premade-or-unframed-the-aberdeen': 1,
    'black-aluminum-privacy-fence-panels-96-wide-x-96-high': 1,
    'black-aluminum-privacy-fence-panels-69-high': 1,
    'black-aluminum-privacy-fence-panels-46-high': 1,
    'black-aluminum-screen-fence-panels-46-high': 1,
    'black-aluminum-screen-fence-panels-72-wide-x-69-high': 1,
    'black-aluminum-privacy-gate-40-wide-x-44-5-high': 1,
    'black-aluminum-privacy-gate-40-wide-x-67-5-high': 1,
    'black-aluminum-screen-gates-40-wide-x-44-5-high': 1,
    'brown-frame-metal-privacy-fence-kit': 1,
    'dark-green-hog-wire-deck-railing-panels-premade-or-unframed-the-cypress': 1,
    '316-stainless-steel-wire-fence-panels': 1,
    '316-stainless-steel-deck-railings': 1,
    '316-stainless-steel-wire-deck-railing': 1,
    'green-hog-wire-fence-panels-hog-panels-premade-or-unframed-the-amazon': 1,
    'green-cattle-panel-fence-cattle-panels-premade-or-unframed-the-galloway': 1,
  };
  function detectSpecialOrder(items) { /*BB_SO_RETIRED 2026-07-19: Special Order discontinued — was forcing a 56-84 day ETA and a SPECIAL ORDER pill on live products. Restore by deleting this return.*/ return false;
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i];
      // Match by handle first — /cart.js does NOT include product_tags reliably
      if (it.handle && SO_PRODUCT_HANDLES[it.handle]) return true;
      var tags = it.product_tags || [];
      for (var j = 0; j < tags.length; j++) {
        if (String(tags[j]).toLowerCase() === 'special-order') return true;
      }
      var opts = it.options_with_values || [];
      var optMap = {};
      for (var k = 0; k < opts.length; k++) {
        var name = String(opts[k].name || '').toLowerCase();
        var val = String(opts[k].value || '');
        optMap[opts[k].name] = val;
        if (/wire.?opening|mesh/.test(name)) {
          if (/\b1\s*["'\u2032\u2033\u201c\u201d\u2019]?\s*[x\u00d7]\s*1\b/i.test(val)) return true;
          if (/\b2\s*["'\u2032\u2033\u201c\u201d\u2019]?\s*[x\u00d7]\s*6\b/i.test(val)) return true;
        }
      }
      if (it.handle && isVariantSOByRules(it.handle, optMap)) return true;
    }
    return false;
  }
  /* ⭐ The Reviews tab's body. Reads window.BB_DRS, published by bb-delivery-rating-badge.liquid —
     Liquid owns the metafield, this owns the slot. Rebuilt with the rest of the panel on every
     render, so there is nothing to re-attach and nothing to wipe.
     ⛔ Fails to an empty string, never throws: this string is concatenated into the card, and a
     throw here would take the whole estimator down. */
  function _bbDrsPanel(){
    /* ⭐ REVIEW CAROUSEL 2026-11-01. One review at a time with arrows either side, replacing the
       vertical scroll list. The nav handler lives on window because this function returns a
       STRING that is rebuilt on every render — anything bound with addEventListener would be
       wiped on the next repaint, and an inline expression carrying a selector needs three levels
       of quote escaping. */
    try {
      var D = window.BB_DRS;
      if (!D || !D.r || !D.r.length) return '<span class="bb-pt-body bb-pt-body--them"></span>';
      if (!window.__bbDrsNav) {
        /* DRS HEIGHT FIT 2026-11-01: the track is a flex row, so without this it stands as tall as the
           LONGEST review and a short quote leaves dead space under it. */
        window.__bbDrsFit = function(t){
          try {
            if (!t || !t.children.length) return;
            var w = t.clientWidth || 1, i = Math.round(t.scrollLeft / w);
            var el = t.children[Math.max(0, Math.min(t.children.length - 1, i))];
            if (el && el.offsetHeight) t.style.height = el.offsetHeight + 'px';
          } catch (e) {}
        };
        window.__bbDrsNav = function(btn, dir){
          try {
            var t = btn.parentNode && btn.parentNode.querySelector('.bb-drs-track');
            if (!t) return;
            t.scrollBy({ left: dir * (t.clientWidth || 220), behavior: 'smooth' });
            setTimeout(function(){ window.__bbDrsFit(t); }, 240);
          } catch (e) {}
        };
        /* scroll does NOT bubble — this must be a capture-phase listener to see track scrolls */
        try { document.addEventListener('scroll', function(e){
          var t = e.target;
          if (t && t.classList && t.classList.contains('bb-drs-track')) window.__bbDrsFit(t);
        }, true); } catch (e) {}
        /* a freshly rendered track has no height and nobody has scrolled it yet. Bounded poll. */
        try { var _n = 0, _iv = setInterval(function(){
          _n++;
          var ts = document.querySelectorAll('.bb-drs-track');
          for (var i = 0; i < ts.length; i++) if (!ts[i].style.height) window.__bbDrsFit(ts[i]);
          if (_n > 20) clearInterval(_iv);
        }, 500); } catch (e) {}
      }
      var esc = function(t){ return String(t == null ? '' : t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
      var out = '';
      for (var i = 0; i < D.r.length; i++) {
        var q = D.r[i] || {}, who = (q.n || '') + (q.c ? ', ' + q.c : '');
        out += '<span class="bb-drs-slide">\u201c' + esc(q.t) + '\u201d'
            + (who ? '<span class="bb-drs-w">\u2014 ' + esc(who) + '</span>' : '')
            + '</span>';
      }
      var nav = D.r.length > 1;
      return '<span class="bb-pt-body bb-pt-body--them" style="text-align:center">'
        + '<strong style="display:block;margin-bottom:5px;font-size:12.5px;line-height:1.35">'
        + '<span style="color:#EB673C;letter-spacing:1px">\u2605\u2605\u2605\u2605\u2605</span> '
        + esc(D.a) + ' \u00b7 ' + esc(D.c) + '+ delivery reviews</strong>'
        + '<span class="bb-drs-wrap">'
        + (nav ? '<button type="button" class="bb-drs-nav" aria-label="Previous review" onclick="window.__bbDrsNav(this,-1)">\u2039</button>' : '')
        + '<span class="bb-drs-track">' + out + '</span>'
        + (nav ? '<button type="button" class="bb-drs-nav" aria-label="Next review" onclick="window.__bbDrsNav(this,1)">\u203a</button>' : '')
        + '</span>'
        + '</span>';
    } catch (e) { return '<span class="bb-pt-body bb-pt-body--them"></span>'; }
  }
  function getShipDates(zone, forceLane) {
    // Base customer-facing ETA per zone, days [min,max] — mirrors the published
    // CA Delivery Zones table: Local(BC) 3-4wk, Express(AB) 4-5wk,
    // Standard(SK) 5-7wk, Long-Haul(East) 7-10wk.
  // ⭐⭐ FLAT ACROSS ZONES, owner 2026-10-21: "the lead times will all be the same for these
  //    zones, it's just the distance the truck has to cover" — a Texas drop rides the California
  //    run. The MEASUREMENT agrees: per-state order-to-ship medians show NO distance signal
  //    (MT 512mi = 23bd is the FASTEST; NM 1,239mi = 50bd the slowest). The wait is the build
  //    queue, not the drive, so the rate is flat and the promise is flat.
  //    Heavy = 20-30 business days = 4-6 weeks.
  var ZONE_ETA = { 1: [10,30], 2: [10,30], 3: [10,30], 4: [10,30] };   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
    /* ZONE-AWARE (owner 2026-07-27): [craneLo,craneHi,quickLo,quickHi] days by province. BC fastest. */
    /* ⛔ BUSINESS DAYS, NOT CALENDAR — checkout counts processingTime (P10D = 10 business
     days) + transit in business days. Adding calendar days made this promise EARLIER than
     checkout in every zone. Weekends skipped; holidays are not modelled, which errs LATE
     (safe) rather than early. */
  /* ⛔ HOLIDAYS SKIPPED TO MATCH CHECKOUT, NOT BECAUSE WE STOP (owner 2026-10-17: "it's not
     like our trucks stop on holidays they're out on the road"). Shopify's checkout date DOES skip
     them and the customer sees both numbers in one session. Measured on a Maryland cart:
     storefront Dec 11-25 vs checkout Dec 17-Jan 4, which reconciles to exactly +1 business day
     once these days come out. Matching them closes the visible gap and errs LATE.
     ⛔⛔ DO NOT re-base transit to calendar days to "be honest about 7-day trucking". The card is
     business days end to end: "2-4 weeks" IS 10-20 business days and the LOW bound is processing
     alone, which is why processing can never exceed 10bd. A 7-day transit basis breaks every
     published label (Light Z1 2-4 -> 2-3.4 wks). */
  var _BB_HOL = {"2026-01-01":1,"2026-04-03":1,"2026-05-18":1,"2026-07-01":1,"2026-09-07":1,"2026-09-30":1,"2026-10-12":1,"2026-11-11":1,"2026-12-25":1,"2027-01-01":1,"2027-03-26":1,"2027-05-24":1,"2027-07-01":1,"2027-09-06":1,"2027-09-30":1,"2027-10-11":1,"2027-11-11":1,"2027-12-24":1,"2027-12-27":1,"2027-12-31":1,"2028-04-14":1,"2028-05-22":1,"2028-06-30":1,"2028-09-04":1,"2028-09-29":1,"2028-10-09":1,"2028-11-10":1,"2028-12-25":1,"2028-12-26":1,"2029-01-01":1,"2029-03-30":1,"2029-05-21":1,"2029-07-02":1,"2029-09-03":1,"2029-10-01":1,"2029-10-08":1,"2029-11-12":1,"2029-12-25":1,"2029-12-26":1,"2030-01-01":1,"2030-04-19":1,"2030-05-20":1,"2030-07-01":1,"2030-09-02":1,"2030-09-30":1,"2030-10-14":1,"2030-11-11":1,"2030-12-25":1,"2030-12-26":1,"2031-01-01":1,"2031-04-11":1,"2031-05-19":1,"2031-07-01":1,"2031-09-01":1,"2031-09-30":1,"2031-10-13":1,"2031-11-11":1,"2031-12-25":1,"2031-12-26":1};
  /* ⭐ re-publish AFTER assignment — the early publish above runs on a hoisted undefined */
  try { window.BB_HOL = _BB_HOL; } catch (e) {}
  function _bbAddBd(n) {
    var d = new Date(); var i = 0;
    while (i < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6) continue;
      if (_BB_HOL[d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)]) continue;
      i++;
    }
    return d;
  }
  var _LT = {BC:[10,30,10,30],AB:[10,30,10,30],SK:[10,30,10,30],MB:[10,30,10,30]};
    /* ⭐⭐ THE CART DECIDES THE DATE WHENEVER IT HOLDS ONE LANE. This read the VIEWED PDP
       VARIANT's framing, and the slide-cart has no variant selectors — so on an Unframed PDP a
       crane-only cart was dated on the LIGHT window while the rate row beside it correctly said
       "Heavy · $199" (measured live 2026-10-17). Same authority as the rate now uses:
       custom.shipping_mode, via __bbCartLanesTruth, refreshed on every cart re-render.
       ⛔ forceLane still wins — the per-lane calls that build the two-truck breakdown must answer
          for their own lane.
       ⛔ A MIXED cart resolves to null on purpose: the span branch below owns it (light low ->
          heavy high) and setting _q here would flatten it to a single lane.
       ⛔ An EMPTY cart still falls back to the viewed variant — a shopper eyeing a framed panel
          with an empty cart is a crane order. */
    var _bbCt = window.__bbCartLanesTruth;
    var _bbCtLane = (_bbCt && (_bbCt.crane || _bbCt.loose) && !(_bbCt.crane && _bbCt.loose))
      ? !_bbCt.crane : null;
    var _q = (forceLane === 'q') ? true : (forceLane === 'c') ? false
      : (_bbCtLane !== null ? _bbCtLane : (bbHogWire && bbIsUnframedNow())), _z = _LT[geoState] || [10,30,10,30];
    var lo = _q ? _z[2] : _z[0], hi = _q ? _z[3] : _z[1];
    // ⭐ 2026-08-12: lead time is no longer flat. Without this, Nova Scotia would be promised the
    // West's 2-4 weeks. Ontario 4-6 · Quebec 5-7 · Maritimes 6-8. West keeps its old numbers.
    var _zn = ZONES[geoState];
    if (_zn && bbIsNewZone(_zn)) {
      /* ⛔ PICK BY LANE. This branch used to hand BOTH lanes the LIGHT table, which is why a
         crane order in Ontario was promised loose-light dates. _q is the loose lane. */
      var _qe = ZONE_QS_ETA[_zn], _ce = ZONE_ETA_C[_zn];
      if (_q && _qe) { lo = _qe[0]; hi = _qe[1]; }
      else if (!_q && _ce) { lo = _ce[0]; hi = _ce[1]; }
      else if (_qe) { lo = _qe[0]; hi = _qe[1]; }
    }
    // Special order adds ANOTHER 4-6 weeks production ON TOP of the zone ETA.

    /* ⭐ MIXED CART = TWO DELIVERIES, ONE TRUE RANGE (owner 2026-10-17: "taking the earliest and
       latest date and spanning it — that gives them the full date range within which their orders
       will arrive"). _z is [craneLo,craneHi,quickLo,quickHi], so the light low is _z[2] and the
       heavy high is _z[1]. ⛔ Only when no lane is forced — the per-lane calls that build the
       mixed-cart breakdown must keep answering for their own lane. */
    if (!forceLane && window.__bbCartLanes && window.__bbCartLanes.loose && window.__bbCartLanes.crane) {
      var _mLo = _z[2], _mHi = _z[1];
      if (_zn && bbIsNewZone(_zn)) {
        var _mq = ZONE_QS_ETA[_zn], _mc = ZONE_ETA_C[_zn];
        if (_mq) _mLo = _mq[0];
        if (_mc) _mHi = _mc[1];
      }
      lo = _mLo; hi = _mHi;
    }
    if (hasSpecialOrderInCart) { lo = 40; hi = 60; }
    var earliest = _bbAddBd(lo);
    var latest = _bbAddBd(hi);
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return { ship: m[earliest.getMonth()] + ' ' + earliest.getDate(),
      arrive: m[latest.getMonth()] + ' ' + latest.getDate(),
      arriveTo: m[latest.getMonth()] + ' ' + latest.getDate(),
      range: m[earliest.getMonth()] + ' ' + earliest.getDate() + ' \u2013 ' + m[latest.getMonth()] + ' ' + latest.getDate(),
     isSpecialOrder: hasSpecialOrderInCart };
  }

  function getCurrentTierIndex(zone, total) {
    var tiers = bbRates()[zone];
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (total >= tiers[i].min) return i;
    }
    return -1;
  }

  var avgItemPrice = 0;

  function panelHint(gap) {
    if (!avgItemPrice || avgItemPrice <= 0) return '';
    var count = Math.ceil(gap / avgItemPrice);
    if (count <= 0) return '';
    var word = count === 1 ? 'panel' : 'panels';
    return ' <span style="color:#888;font-weight:400">(\u2248' + count + ' more ' + word + ')</span>';
  }

  function renderElement(ctx, cartTotal) {
    var el = document.getElementById('bb-ship-est-' + ctx);
    if (!el || !geoState || !geoZone) return;

    var headerEl = document.getElementById('bb-ship-header-' + ctx);
    var statusEl = document.getElementById('bb-ship-status-' + ctx);
    var tiersEl = document.getElementById('bb-ship-tiers-' + ctx);
    var deliveryEl = document.getElementById('bb-ship-delivery-' + ctx);
    var progressEl = document.getElementById('bb-ship-progress-' + ctx);
    var barEl = document.getElementById('bb-ship-bar-' + ctx);
    if (!statusEl || !tiersEl || !deliveryEl || !progressEl || !barEl) return;

    // === PAUSED PROVINCE — no rates, show pause notice + future-window CTA ===
    // ⭐⭐ 2026-08-12 lane-aware (mirrors the USA estimator). Fires ONLY when the province has no
    // service at all, or when the cart/variant needs a CRANE the truck can't reach. A Loose Truck
    // shopper in ON/QC/NB/NS/PE must get a real rate, not "we've paused your area".
    // ⚠️ bbCraneNow() reads the CART by design, so it is false for someone merely VIEWING a
    // framed variant — check the viewed variant too, or the nudge never fires on the PDP.
    var bbUnserved = !!UNSERVED_PROVINCES[geoState];
    var bbPdpEl    = document.getElementById('bb-ship-est-product');
    var bbPdpCrane = bbPdpCraneNow();   // single source of truth, shared with bbRates()
    var bbHasLooseAlt = !!bbHogWire;   // only nudge where an Unframed twin actually exists
    var bbCraneBlocked = (bbCraneNow() || bbPdpCrane) && !!CRANE_PAUSED_PROVINCES[geoState] && !bbUnserved;
    var bbQsReaches = !!ZONES[geoState] && !bbUnserved;
    if (bbUnserved || bbCraneBlocked) {
      var _rnP = STATE_NAMES[geoState] || geoState;
      var pLoc = geoCity ? (geoCity + ', ' + geoState) : _rnP;
      var pVia = 'in <strong>Q1 2028</strong> when our new <strong>Ontario fulfillment centre</strong> opens';
      if (headerEl) {
        headerEl.innerHTML = (bbCraneBlocked && bbQsReaches && bbHasLooseAlt)
          ? '<span class="bb-ship-header__zone">🚚 Delivering to <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">Unframed only</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>'
          : (bbCraneBlocked && bbQsReaches)
            // Crane-only PRODUCT in a Loose Truck zone — the limit is the item, not the address.
            ? '<span class="bb-ship-header__zone">🚚 Delivering to <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">Your order</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>'
            // Genuinely off our routes. No resume date — the old RESUME_INFO quarters were
            // written for the pre-expansion pause and are not a commitment we can keep.
            : '<span class="bb-ship-header__zone">🚚 <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">' + (typeof PAUSED_REGIONS !== 'undefined' && PAUSED_REGIONS[geoState] ? 'new orders paused' : 'not on our routes yet') + '</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>';
      }
      statusEl.style.display = ''; // notice lives in statusEl — re-show it (served path hides it)
      // Widened: a crane-only product (no unframed twin) in a Loose Truck zone used to fall
      // through to "we don't deliver to <state>", which is false — we do, just not this item.
      if (bbCraneBlocked && bbQsReaches) {
        var nzE = ZONE_QS_ETA[ZONES[geoState]] || [28,42];
        // Owner 2026-08-12: "4-6 weeks and 6-8 weeks is sticker shock — soften it with date ranges".
        var _nzM = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var _nzD1 = new Date(Date.now() + nzE[0] * 86400000);
        var _nzD2 = new Date(Date.now() + nzE[1] * 86400000);
        var nzW = _nzM[_nzD1.getMonth()] + ' ' + _nzD1.getDate() + ' \u2013 ' + _nzM[_nzD2.getMonth()] + ' ' + _nzD2.getDate();
        var nzR = RATES[ZONES[geoState]];
        var nzF = (nzR && nzR.length) ? nzR[0].label : '';
        var bbCraneOnlyHere = !bbHasLooseAlt;   // no unframed twin => the ITEM is the limit
        if (bbCraneOnlyHere) {
          statusEl.innerHTML =
            '<div style="text-align:left;line-height:1.5;">' +
            '<strong>This one travels on our crane truck, which we run in BC, Alberta, Saskatchewan &amp; Manitoba.</strong> ' +
            'Crane truck items aren\u2019t available in ' + pLoc + ' yet \u2014 but plenty is. ' +
            '<strong>Unframed hog wire panels, cattle panel and deck railing</strong> all ship to you with ' +
            '<strong>BARRIERBOSS Residential Delivery</strong>, delivered and unloaded on your property' +
            (nzF ? ' \u2014 from <strong>' + nzF + '</strong>' : '') + ', arriving <strong>' + nzW + '</strong>.' +
            '<div style="margin-top:8px;"><a href="/collections/hog-fencing" style="display:inline-block;font-weight:700;text-decoration:underline;color:#EB673C;">Shop what ships to ' + pLoc + ' \u2192</a></div>' +
            '</div>';
        } else {
        statusEl.innerHTML =
          '<div style="text-align:left;line-height:1.5;">' +
          '<strong>We deliver to ' + pLoc + ' — but not the assembled/framed version yet.</strong> ' +
          'Our crane truck runs in BC, Alberta, Saskatchewan &amp; Manitoba. ' +
          '<strong>Switch Frame Type to “Unframed”</strong> and this panel ships to you with ' +
          '<strong>BARRIERBOSS Residential Delivery</strong> — delivered and unloaded on your property' +
          (nzF ? ' — from <strong>' + nzF + '</strong>' : '') + ', arriving <strong>' + nzW + '</strong>.' +
          '</div>';
        }
      } else {
        /* ⛔ pWhen/pHub are USA-only identifiers. Referencing them here threw and killed the
           body render. Canada has no hub, so these resolve to null and the Resumes block is
           omitted — the rest of the copy matches the USA card exactly. */
        var _riC = ((typeof RESUME_INFO !== 'undefined' && RESUME_INFO) || window.BB_RESUME_INFO || {})[geoState] || [null, null];
        var pWhen = _riC[0], pHub = _riC[1];
        statusEl.innerHTML = (typeof PAUSED_REGIONS !== 'undefined' && PAUSED_REGIONS[geoState])
          ? ('<div style="text-align:center;line-height:1.55;">'
             + '<strong style="color:#bf360c">New orders to ' + _rnP + ' are paused.</strong> '
             + 'We can’t keep up with demand, so we’ve paused new orders here while we catch up. Existing orders are unaffected and ship as scheduled.'
             + (pWhen ? ('<div style="margin-top:10px;padding:10px 12px;background:#FDF1EC;border-radius:8px;"><strong>Resumes '
                 + pWhen + '</strong>' + (pHub ? ' · when our ' + pHub + ' hub opens' : '') + '</div>') : '')
             + '<div style="margin-top:10px;"><a href="/pages/new-facilities#reserve" style="font-weight:700;color:#EB673C;">Reserve a delivery window →</a></div>'
             + '</div>')
          : ('<div style="text-align:center;line-height:1.5;">'
             + '<strong>We don’t deliver to ' + pLoc + '.</strong> '
             + 'We move every panel on our own trucks and unload it on your property — we don’t hand freight to LTL carriers, '
             + 'so we’d rather say so plainly than take an order we can’t deliver properly. '
             + '<span style="color:#555;">Already ordered? Your order is unaffected and ships as scheduled.</span>'
             + '<div style="margin-top:8px;"><a href="/pages/contact" style="display:inline-block;font-weight:700;text-decoration:underline;color:#EB673C;">Tell us where you are →</a> '
             + '<span style="color:#888;font-size:11px;">We’ll let you know if that ever changes.</span></div>'
             + '</div>');
      }
      tiersEl.innerHTML = '';
      progressEl.style.display = 'none';
      deliveryEl.style.display = 'none';
      var pTrustEl = document.getElementById('bb-ship-trust-' + ctx);
      if (pTrustEl) pTrustEl.innerHTML = '';
      if (!el.dataset.ga4Viewed) {
        el.dataset.ga4Viewed = '1';
        ga4Event('bb_estimator_paused_view', { context: ctx, province: geoState, cart_total: cartTotal / 100 });
      }
      el.style.display = 'block';
      var _pzEls = document.querySelectorAll('[id="bb-ship-zip-' + ctx + '"]');
      for (var _pzi = 0; _pzi < _pzEls.length; _pzi++) _pzEls[_pzi].style.display = 'none';
      return;
    }
    // FREIGHT REBUILD 2026-07-09: no free goal to fill toward — the hero states
    // the real per-cart delivery cost. Progress bar retired (was "spend to free").
    progressEl.style.display = 'none';

    var tiers = bbRates()[geoZone];
    var currentIdx = getCurrentTierIndex(geoZone, cartTotal);
    var freeTier = tiers[tiers.length - 1];
    var atFree = cartTotal >= freeTier.min;

    // Celebration animation + GA4 event
    if (currentIdx > lastTierIndex && lastTierIndex >= 0) {
      el.classList.remove('bb-ship-est--celebrating');
      void el.offsetWidth;
      el.classList.add('bb-ship-est--celebrating');
      ga4Event('bb_estimator_tier_unlock', {
        zone: geoZone, province: geoState, tier: currentIdx,
        rate_label: tiers[currentIdx].label, cart_total: cartTotal / 100
      });
    }
    lastTierIndex = currentIdx;

    var thumbEl = document.getElementById('bb-ship-thumb-' + ctx);

    // === PROGRESS BAR (spans $0 to FREE tier) ===
    var freeMin = freeTier.min;
    var progressPercent;
    if (atFree) {
      progressPercent = 100;
      progressEl.classList.add('bb-ship-progress--complete');
    } else {
      progressEl.classList.remove('bb-ship-progress--complete');
      progressPercent = Math.min(Math.max((cartTotal / freeMin) * 100, 1), 99);
    }
    barEl.style.width = progressPercent + '%';
    if (thumbEl) {
      thumbEl.style.position = 'absolute';
      thumbEl.style.left = progressPercent + '%';
    }

    // === STATUS — hidden (owner 2026-07, ported from USA): the delivered-price
    // hero shows the current rate, so the "add \$X" status line is redundant.
    // (The paused-province notice above still uses statusEl and re-shows it.)
    statusEl.innerHTML = '';
    statusEl.style.display = 'none';

    // === TIER MARKERS ON SLIDER ===
    var tierHtml = '';
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var isUnlocked = i <= currentIdx;
      var isCurrent = i === currentIdx;
      var isFree = t.rate === 0;
      var pct = (t.min / freeMin) * 100;

      var cls = 'bb-ship-tier';
      if (isFree) cls += ' bb-ship-tier--free';
      if (isCurrent) cls += ' bb-ship-tier--current';
      else if (isUnlocked) cls += ' bb-ship-tier--unlocked';
      else cls += ' bb-ship-tier--locked';

      var rateLabel = isFree ? 'FREE' : t.label;
      tierHtml += '<div class="' + cls + '" style="left:' + pct + '%">' + rateLabel + '</div>';
    }
    tiersEl.innerHTML = tierHtml;
    // Slider/ladder REMOVED both contexts (owner 2026-07, ported from USA) — the
    // dynamic hero token shows the current rate. Computation above is now inert.
    var _sliderEl = document.getElementById('bb-ship-slider-' + ctx);
    if (_sliderEl) _sliderEl.style.display = 'none';

    // === HEADER — zone + location ===
    var _rnL = STATE_NAMES[geoState] || geoState;
    var locationStr = geoCity ? (geoCity + ', ' + geoState) : _rnL;
    var dates = getShipDates(geoZone);
    // Formatted ETA range (e.g. "Aug 18–Sep 1") — shared by the merged hero
    // delivery line and the no-hero fallback. CA getShipDates() → dates.range.
    var _etaStr = (function(a){var m=(a||'').match(/^([A-Za-z]+) (\d+)\s*[–-]\s*([A-Za-z]+) (\d+)$/);return m?(m[1]===m[3]?m[1]+' '+m[2]+'–'+m[4]:m[1]+' '+m[2]+'–'+m[3]+' '+m[4]):a;})(dates.range);
    try { window.BB_ETA = { etaStr: _etaStr }; } catch (e) {}
    // Peak-season subline (Apr-Nov). Off-peak: clean header, no subline. Extended 2026-10-02: the row is branded "Fall Rush" but the window ended 30 Sep, so it switched off exactly as fall began. Months are 0-indexed. ⛔ Hardcoded in BOTH stores — change them together or the two drift.
    var _peakMonths = [] /* Fall Rush RETIRED 2026-11-01 — unbacked scarcity. Refill to revive. */;
    var _isPeak = _peakMonths.indexOf(new Date().getMonth()) !== -1;
    var _bbRegionNames = {"BC":"British Columbia","AB":"Alberta","SK":"Saskatchewan","MB":"Manitoba","ON":"Ontario","QC":"Quebec","NS":"Nova Scotia","NB":"New Brunswick","NL":"Newfoundland","PE":"Prince Edward Island","YT":"Yukon","NT":"Northwest Territories","NU":"Nunavut"};
    var _bbLocale = (geoCity && String(geoCity).trim()) ? String(geoCity).trim() : ((geoState && _bbRegionNames[geoState]) ? _bbRegionNames[geoState] : '');
    /* ⭐ published so the slide-cart Fall Rush STAND-IN can name the town too. The stand-in
       lives in bb-cart-monitor.js and had no geo of its own, which is why the cart said
       "the next truck" while the PDP said "the next truck to Beverly Hills". */
    try { window.BB_LOCALE = _bbLocale; } catch (e) {}
    var _routePhrase = _bbLocale ? ('Spots on the next truck to ' + _bbLocale + ' are filling fast') : 'Spots on the next outbound truck are filling fast';
    var _trustBadges = '<div style="padding:8px 14px 10px;border-top:1px solid rgba(0,0,0,.06);text-align:center;">'
      + '<button type="button" aria-expanded="false" onclick="var p=this.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-lanecaret]\');if(c)c.textContent=o?\'\u25B4\':\'\u25BE\';" style="background:none;border:0;padding:2px 0 0;margin:0;cursor:pointer;font:inherit;font-size:13px;font-weight:600;opacity:1;color:inherit;display:inline-flex;align-items:center;gap:4px;justify-content:center;">'
      + '\uD83D\uDE9A Save on Freight &amp; Get it Sooner <span data-bb-caret data-bb-lanecaret style="font-size:9px;">\u25BE</span></button>'
      + '<div style="display:none;font-size:11.5px;line-height:1.55;opacity:.9;margin-top:6px;text-align:center;">'
      + '<div style="margin-bottom:4px;"><strong>Light</strong> &mdash; unframed panels, wire and rolls. Lower freight rate, arrives sooner.</div>'
      + '<div><strong>Heavy</strong> &mdash; framed panels, gates and Zero-Maintenance. Higher freight rate, takes longer.</div>'
      + ''
      + ''
      + '</div></div>';
    var _subline = (_isPeak) ? '<div style="padding:8px 14px 10px;border-top:1px solid rgba(0,0,0,.06);text-align:center;"><button type="button" aria-expanded="false" onclick="var p=this.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-caret]\');if(c)c.textContent=o?\'▴\':\'▾\';" style="background:none;border:0;padding:2px 0 0;margin:0;cursor:pointer;font:inherit;font-size:13px;font-weight:600;opacity:1;color:inherit;display:inline-flex;align-items:center;gap:4px;justify-content:center;">🍂 Fall Rush — Reserve Your Spot. <span data-bb-caret style="font-size:9px;">▾</span></button><div class="bb-peak-collapse" style="display:none;"><div style="font-size:11px;opacity:0.9;margin-bottom:6px;text-align:center;line-height:1.4;">' + _routePhrase + ' \u2014 most orders ship earlier than the window above.</div><div style="font-size:10px;opacity:0.7;margin-top:5px;text-align:center;">Book your installer only after shipment confirmation.</div></div></div>' : '';
    if (headerEl) {
      var homeownerBadge = '';
      var _dpHero = '';
      try {
        if (bbRates()[geoZone] && cartTotal >= 0) {
          var _dpT = bbRates()[geoZone];
          var _dpMin = _dpT[0].min;                    // zone's lowest-tier minimum (real, per-zone; CA currency)
          var _emptyCart = cartTotal === 0;            // standing "add $X for free delivery" prompt
          var _belowMin = cartTotal < _dpMin;
          /* ⭐ GATE THE TWO-TRUCK BOX HERE, inline. Under the floor there is no delivery, so the
             box must not describe how it splits. Deliberately NOT a MutationObserver: the earlier
             observer version fed itself and took the site down. renderElement already runs on
             every cart and geo change, which is exactly when this can change.
             ⚠️ Only ever hides — bb-cart-monitor.js hides the same element for paused regions. */
          try {
            if (_belowMin) {
              var _mxN = document.querySelectorAll('[data-bb-mixnote]');
              for (var _mxI = 0; _mxI < _mxN.length; _mxI++) _mxN[_mxI].style.display = 'none';
            }
          } catch (e) {}
          /* ⭐ ONE SOURCE for "does this cart qualify" — the two-truck box reads this, so it can
             never disagree with the chip about whether delivery exists yet. */
          try { window.BB_BELOW_MIN = _belowMin; } catch (e) {}          // under the regional minimum -> no delivery rate yet
          var _dpI = getCurrentTierIndex(geoZone, cartTotal);
          // At/above the minimum a tier matches -> real delivery rate; below it, no rate is added.
          var _dpR = (!_belowMin && _dpI >= 0 && _dpI < _dpT.length) ? _dpT[_dpI].rate : 0;
          var _dpFree = !_belowMin && _dpR === 0;
          // FREE-DELIVERY THRESHOLD — derived from the rate table, never hardcoded: the first
          // tier priced at 0. Follows any reprice of the freight card automatically.
          var _dpFreeAt = 0;
          for (var _fi = 0; _fi < _dpT.length; _fi++) { if (_dpT[_fi].rate === 0) { _dpFreeAt = _dpT[_fi].min; break; } }
          var _dpShort = _dpFreeAt > 0 ? (_dpFreeAt - cartTotal) : 0;
          var _dpChasing = _dpFreeAt > 0 && _dpShort > 0;
          // The nudge REPLACES the trust tail while chasing (owner: the two lines said the same
          // thing). Trust copy returns once the threshold is cleared and no nudge is left.
          // "FREE delivery" uses the ratetoken class, not <strong> — the class is
          // {color:#EB673C;font-weight:700}, so it goes ORANGE and stays bold, pairing with the
          // already-orange gap amount. "we unload" is the moat phrase in the shortest form that
          // fits the slide cart (~52 ch); both lines below are 40-42. NEVER "curb"/"curbside".
          // ⛔ NO GAP CLAUSE HERE. The rail below shows "$X to go" on the pill; repeating it in
          // words is the same fact twice, 20px apart — that is what killed the first rail.
          /* ⛔ do NOT repeat the card header ("MADE, MOVED & UNLOADED BY US") — it read twice on one
             screen. These two facts are the ones the header does not carry. */
          var _dpTrust = '<span style="display:block;margin-top:5px;font-size:11px;font-weight:700;letter-spacing:0.2px;color:#111111;line-height:1.35">Factory Direct &middot; No Surcharges &middot; Freight Insured</span>';
          // MIXED CART — the cart spans both delivery profiles and Shopify SUMS THEM, so explain
          // the two fees and give the lever that removes one: match the product type, don't mix.
          // Splitting into two orders does NOT help (each order carries its own lane) — only a
          // single-type cart pays a single fee, so that is what we say.
          // Both rates are read from the live ladders at THIS cart's band index, so a reprice can
          // never leave this sentence quoting a number checkout no longer charges.
          try {
            // A mixed cart is charged BOTH delivery profiles — the fees STACK. This runs below the
            // $500 minimum too, because the panel prints a rate there and a number with no reason
            // beside it is the whole complaint. Rendered as separate lines rather than a sentence:
            // the cart is the last place the shopper can act on this, so it must scan at a glance.
            if (bbCartMixedNow() && !_emptyCart) {
              // getCurrentTierIndex() returns -1 BELOW the lowest band, and RATES[zone][-1] is
              // undefined — which silently collapsed both fees to 0 and printed "both delivered
              // FREE" on a $499.98 cart that cannot even check out. Clamp to the first band, the
              // same fallback _dpShowR uses, so the sentence always matches the price beside it.
              var _bbI = (_dpI >= 0) ? _dpI : 0;
              var _bbQS = (RATES[geoZone] && RATES[geoZone][_bbI]) ? RATES[geoZone][_bbI].rate : 0;
              var _bbCR = (CRANE_RATES[geoZone] && CRANE_RATES[geoZone][_bbI]) ? CRANE_RATES[geoZone][_bbI].rate : 0;
              var _bbQSn = '', _bbCRn = '';
              // Second, independent guard: below the minimum there is NO rate at all, so the free
              // band cannot apply no matter what the ladder lookup returned.
              if (!_belowMin && (_dpFree || (_bbQS === 0 && _bbCR === 0))) {
                // At/above the free band BOTH lanes are $0 — there is no freight to save and
                // nothing to explain, so the panel keeps its default trust line untouched. Replacing
                // it here was the same bug as before: losing the moat line to say something the
                // shopper does not need.
              } else {
                // Consolidating to ONE lane drops the LARGER fee (an all-Quick-Ship cart pays the
                // small one), so the saving is max(), not the sum and not the difference.
                // The saving is THE FEE YOU DROP, not the larger of the two. Consolidating onto
                // Loose Truck removes the CRANE fee, so the saving is _bbCR by construction — true
                // at any future rate. Going all-crane would save only _bbQS, which is exactly why
                // the line below has to NAME the lane rather than say "one type" and imply either.
                // Each option's saving is THE FEE IT DROPS — never the larger fee, never a single
                // number for both. Quick-only drops the crane fee; crane-only drops the quick fee.
                // Each option's saving is THE FEE IT DROPS. Quick-only drops the crane fee;
                // crane-only drops the quick fee. Never one figure for both — that was wrong by
                // $100 for anyone who consolidated the other way.
                var _bbSaveQ = _bbCR, _bbSaveC = _bbQS;
                // Capture the default trust copy BEFORE overwriting _dpTrust — assigning over it is
                // what silently dropped "We Unload · no surcharges, freight insured" from every
                // mixed cart, the one claim here no competitor can make.
                var _bbTrust0 = _dpTrust;
                var _bbLn = 'display:block;text-align:center;';
                // Detail, hidden until asked for.
                // Label left, price right — a price COLUMN is scannable; a price buried mid-sentence
                // is not. Bold is spent on the two amounts only (600, not 700); the savings and the
                // supporting lines are muted 11px. One level of emphasis instead of four.
                // Declared HERE deliberately: this string's previous declaration lived in a layout
                // that was replaced, and the reference outliving it threw a ReferenceError that the
                // enclosing try/catch swallowed — silently killing the whole dropdown.
                var _bbNW = 'white-space:nowrap;';
                var _bbRow = function (label, amt, note) {
                  // ⛔ The opening string MUST stay on the same line as the "return" keyword. A comment
                  // between them triggers automatic semicolon insertion (an empty "return;") and the row
                  // then silently renders as
                  // 'undefined'. node --check passes, because it is valid JavaScript. Caught only by
                  // executing the block (_freight_block_smoketest.mjs).
                  // Tight line-height: the two options are one comparison and should read as a pair.
                  return '<span style="display:flex;justify-content:space-between;align-items:baseline;gap:12px;line-height:1.35;">' +
                    '<span>' + label + '</span>' +
                    '<span style="' + _bbNW + '"><span style="font-weight:600;">' + amt + '</span>' +
                    '<span style="opacity:.6;font-size:11px;margin-left:6px;">' + note + '</span></span></span>';
                };
                // Centred (owner): the two supporting lines read as sentences, not columns — only the two
                // option ROWS below keep left/right alignment, because those are a price column.
                var _bbMuted = 'display:block;text-align:center;opacity:.7;font-size:11px;line-height:1.45;';
                var _bbDetail =
                  // The WHY. The rows below already name both categories, so the sentence does not.
                  '<span style="' + _bbMuted + 'margin-bottom:4px;">Freight is charged per category ' +
                  '&mdash; your cart has both.</span>' +
                  // Constrained width, centred (owner: bring the labels closer TO THE PRICES). space-between
                  // across the full panel pushed each label and its price to opposite edges; capping the
                  // row keeps the price COLUMN aligned — so the two options still compare cleanly —
                  // while closing the gap between a label and its own number.
                  '<span style="display:block;text-align:left;max-width:250px;margin:0 auto;">' +
                  _bbRow(_bbQSn + ' only', money(_bbQS), 'save ' + money(_bbSaveQ)) +
                  _bbRow(_bbCRn + ' only', money(_bbCR), 'save ' + money(_bbSaveC)) +
                  '</span>';
                if (!_belowMin && _dpChasing && _dpShort > 0) {
                  // Gap CEILINGS to the dollar exactly as the rail pill does; plain money() rounds
                  // DOWN and would advertise a gap smaller than the real one.
                  _bbDetail += '<span style="' + _bbMuted + 'margin-top:5px;">Or add ' +
                    money(Math.ceil(_dpShort / 100) * 100) + ' and both ship free.</span>';
                }
                // Same collapse mechanic as the peak-season block above: inline onclick, sibling
                // span, caret swap. The sibling MUST stay immediately after the button.
                // Order matters (owner): the number, then the moat line, THEN the little button.
                // Collapsed, the panel reads exactly as it did before any of this existed.
                var _bbTxt = '<span style="' + _bbLn + '">' + _bbTrust0 + '</span>' +
                  '<span style="' + _bbLn + 'margin-top:5px;">' +
                  '<button type="button" aria-expanded="false" onclick="var p=this.parentNode.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-caret]\');if(c)c.textContent=o?\'\u25B4\':\'\u25BE\';" ' +
                  'style="background:none;border:0;padding:0;margin:0;cursor:pointer;font:inherit;font-size:12px;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:2px;display:inline-flex;align-items:center;gap:4px;">' +
                  'How to save on freight <span data-bb-caret style="font-size:9px;">\u25BE</span></button></span>' +
                  '<span class="bb-frt-collapse" style="display:none;margin-top:5px;">' + _bbDetail + '</span>';
                _dpTrust = _bbTrust0; /* toggle moved to the bottom strip (_bbTogs) */
              }
            }
          } catch (e) {}
          var _dpDisc = (window.BB_DISCOUNT && window.BB_DISCOUNT.rate) ? window.BB_DISCOUNT.rate : 0;
          // CA payment method = Interac e-Transfer (data-driven via bb_discount
          // metafield; fallback hardened to Interac for the CA store).
          var _dpPay = (window.BB_DISCOUNT && window.BB_DISCOUNT.paymentMethod) ? window.BB_DISCOUNT.paymentMethod : 'Interac e-Transfer';
          // Interac hint on the subtotal; suppressed on an empty cart (no price to discount).
          var _dpHint = (/* BB 2026-10-23 owner: bank hint RESTORED under the total, above the BARRIERBOSS/Others toggle */ !_emptyCart && !_belowMin && _dpDisc > 0) ? '<span class="bb-ship-allin__ach" style="display:block;margin:10px 0 5px;line-height:1.4;font-size:12px;text-wrap:balance"><svg width="17" height="12" style="vertical-align:-2px;margin-right:6px" role="img" aria-label="Interac" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 560 400" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" transform="matrix(.506259 0 0 .506259 -23.7552 -2.50349)"><path d="m385.351 142.422h429.292.003c23.551 0 42.931 19.379 42.933 42.931v429.301c-.002 23.549-19.38 42.927-42.93 42.927-.001 0-.002 0-.003 0h-429.301c-23.546 0-42.922-19.375-42.924-42.921v-429.31c.002-23.55 19.38-42.928 42.93-42.928z" fill="#fdb913"/><path d="m814.652 142.419c23.548.007 42.922 19.385 42.924 42.934v429.297c-.002 23.548-19.376 42.926-42.924 42.931h-429.298c-.003 0-.006 0-.009 0-23.546 0-42.921-19.376-42.921-42.921 0-.003 0-.006 0-.01v-429.297c0-.003 0-.007 0-.01 0-23.547 19.377-42.924 42.924-42.924h.006zm0-9.086h-429.298c-28.525.03-51.988 23.495-52.016 52.02v429.297c.032 28.524 23.493 51.985 52.016 52.017h429.298c28.522-.034 51.98-23.495 52.01-52.017v-429.297c-.027-28.524-23.487-51.988-52.01-52.02" fill="#fff"/><g fill="#231f20"><path d="m630.06 405.561-.043-92.235 24.076-5.714v12.095s6.237-15.902 20.709-19.593c2.161-.696 4.461-.85 6.696-.449v23.533c-4.335.057-8.618.948-12.615 2.626-8.896 3.513-13.373 11.179-13.373 22.882l.015 50.93zm-126.914 29.994s-3.918-5.87-3.918-26.625v-45.92l-12.385 2.947v-18.922l12.416-2.932v-20.626l25.6-6.044v20.623l18.086-4.297v18.898l-18.086 4.294s-.031 37.626 0 46.761c0 21.266 5.643 25.349 5.643 25.349zm42.477-54.872c0-16.397 2.335-28.36 7.348-37.541 5.967-10.894 15.745-17.994 29.994-21.238 28.084-6.387 38.223 10.237 37.828 32.528-.15 7.972-.113 11.856-.113 11.856l-49.479 11.629v.795c0 15.577 3.265 22.968 13.135 20.872 8.526-1.797 10.898-7.137 11.571-13.741.11-1.065.162-3.773.162-3.773l23.179-5.555s.055 1.898.021 4.028c-.202 8.85-2.775 30.805-34.991 38.422-30.518 7.244-38.652-11.394-38.652-38.285m38.367-41.596c-8.199 1.861-12.498 9.904-12.685 23.228l24.89-5.928c.042-.602.049-1.931.042-4.012-.042-10.059-3.152-15.369-12.247-13.288m184.154-12.339c-.96-28.09 6.326-50.385 37.667-57.485 19.975-4.538 27.561.658 31.402 5.68 3.694 4.793 5.12 11.256 5.12 20.308l.021 1.662-24.519 5.827-.019-3.412c.019-10.736-2.965-14.818-10.763-12.866-9.272 2.329-13.018 11.131-13.018 28.63 0 6.212.03 7.326.03 8.164 0 17.784 2.427 25.924 13.114 23.687 9.273-1.915 10.54-10.056 10.689-17.193.019-1.12.065-4.706.065-4.706l24.482-5.784s.025 1.808.025 3.819c-.061 23.32-12.352 38.015-35.377 43.374-31.724 7.436-37.936-10.895-38.922-39.705m-84.758 39.328c0-21.367 12.517-28.124 31.356-35.919 16.942-7.008 17.309-10.487 17.379-16.577.092-5.126-2.283-9.512-10.717-7.36-5.77 1.163-10.018 6.183-10.209 12.066-.138 1.575-.191 3.155-.159 4.735l-23.754 5.609c-.16-4.734.393-9.465 1.64-14.034 3.795-12.777 15.066-21.374 34.517-25.875 25.272-5.824 33.694 5.267 33.725 22.518v40.852c0 19.757 3.669 22.652 3.669 22.652l-23.319 5.518c-1.287-2.695-2.332-5.498-3.125-8.376-.793-2.879-5.111 12.865-22.717 17.003-18.493 4.361-28.286-7.1-28.286-22.812m48.573-29.177c-3.93 2.756-8.08 5.186-12.406 7.265-7.773 3.798-11.287 8.484-11.287 15.7 0 6.249 3.872 10.353 10.907 8.615 7.547-1.904 12.786-8.946 12.786-18.729zm-362.665 163.314c-8.114-.01-14.785-6.689-14.785-14.803 0-2.857.827-5.654 2.381-8.051l.165-.215.276-.073 34.823-8.22v26.444l-.542.126c-6.415 1.544-12.843 3.037-19.283 4.477-.998.211-2.015.317-3.035.315m0 33.829c-8.105.001-14.776-6.662-14.785-14.766-.008-2.855.82-5.65 2.381-8.04l.165-.245.276-.073 34.823-8.217v26.444l-.542.141c-7.898 1.897-17.339 4.082-19.283 4.471-1 .194-2.017.289-3.035.285m0 33.896c-8.108-.005-14.778-6.674-14.785-14.782-.01-2.853.818-5.648 2.381-8.036l.165-.266 35.099-8.272v26.441l-.542.144c-8.342 2.007-17.606 4.101-19.283 4.468-.999.201-2.016.302-3.035.303m22.857-254.465v147.96l-26.967 6.377-.01-147.963zm40.225 141.747c.001-.075.001-.15.001-.225 0-9.132-7.513-16.645-16.645-16.645-9.131 0-16.645 7.513-16.645 16.645 0 .075.001.15.002.225l.03 138.296c.03 24.698 20.334 45.018 45.033 45.066 12.599 0 47.113-.061 47.113-.061l.016-57.693.015-64.337c.008-7.277-3.63-14.094-9.68-18.139l-41.987-28.522-.012 64.766c0 1.964-1.617 3.58-3.581 3.58s-3.581-1.616-3.581-3.58c0-.695-.079-70.819-.079-79.373m22.478-103.181c-10.32 2.394-19.096 9.179-24.011 18.564v-10.399l-24.29 5.747.031 66.409c8.673-3.429 18.576-1.698 25.571 4.471v-42.875c0-10.274 5.111-18.478 12.413-20.088 5.493-1.206 10.081.759 10.081 10.543l.018 62.559 25.584-5.999v-66.179c0-16.045-6.178-27.261-25.397-22.753m371.724-94.702c-.005 0-.01 0-.015 0-8.676 0-15.816-7.139-15.816-15.815 0-8.677 7.14-15.816 15.816-15.816s15.815 7.139 15.815 15.816v.012c-.008 8.666-7.134 15.795-15.8 15.806m0-29.639c-.001 0-.002 0-.003 0-7.587 0-13.83 6.243-13.83 13.83 0 7.586 6.243 13.829 13.83 13.829 7.586 0 13.828-6.241 13.83-13.826-.007-7.584-6.243-13.823-13.827-13.833"/><path d="m820.819 232.111h6.815c.158-.017.316-.025.475-.025 2.444 0 4.456 2.011 4.456 4.456 0 .176-.011.352-.032.527 0 2.506-1.11 4.431-3.213 4.759v.036c1.913.196 2.92 1.252 3.018 3.967.036 1.224.055 2.742.113 3.923.003.675.349 1.304.918 1.668h-3.486c-.332-.511-.513-1.105-.52-1.714-.107-1.154-.08-2.243-.132-3.645-.052-2.105-.697-3.03-2.812-3.03h-2.522v8.386h-3.078zm5.545 8.6c.086.007.172.011.258.011 1.558 0 2.84-1.282 2.84-2.84 0-.101-.006-.202-.016-.302 0-2.06-.888-3.143-2.92-3.143h-2.629v6.274z"/></g></g></svg><strong>Save ' + Math.round(_dpDisc*100) + '%</strong> with <span style="font-weight:700">E-Transfer</span> at&nbsp;Checkout</span>' : '';
          // DYNAMIC delivered line (2026-07, ported from USA): at/above the zone
          // minimum it reads the normal "Delivered & Unloaded ... for FREE|$X";
          // below the minimum (incl. an empty cart, where need = the full minimum)
          // it flips to "Regional minimum is $MIN · add $NEED more" (need = min - subtotal).
          if(!document.getElementById('bb-dtog-style')){try{var _bbds=document.createElement('style');_bbds.id='bb-dtog-style';_bbds.textContent='.bb-pt{display:block;margin-top:3px;}.bb-pt .bb-pt-r{position:absolute;width:0;height:0;opacity:0;pointer-events:none;}.bb-pt-seg{display:inline-flex;align-items:center;background:#f2f2f3;border:1px solid #e5e5e7;border-radius:8px;padding:2px;gap:2px;}.bb-pt-opt{cursor:pointer;margin:0;font-size:10px;font-weight:700;padding:2px 10px;border-radius:6px;color:#8a9099;line-height:1.55;min-width:92px;text-align:center;box-sizing:border-box;-webkit-user-select:none;user-select:none;letter-spacing:.2px;transition:background .12s,color .12s;}.bb-pt-body{display:none;font-size:12px;line-height:1.35;font-weight:600;margin-top:6px;min-height:2.7em;padding:8px 10px;margin-left:-12px;margin-right:-12px;border-radius:10px;border:1px solid transparent;box-sizing:border-box;}.bb-pt-body--us{color:#151515;background:rgba(235,103,60,0.06);}.bb-pt-body--them{color:#8a9099;background:rgba(0,0,0,.035);}.bb-pt-body--them:has(.bb-drs-track){color:#4a4a4a;}.bb-drs-wrap{display:flex;align-items:stretch;gap:2px;}.bb-drs-track{flex:1 1 auto;min-width:0;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;}.bb-drs-track::-webkit-scrollbar{display:none;}.bb-drs-slide{flex:0 0 100%;scroll-snap-align:center;box-sizing:border-box;padding:2px 4px 0;font-size:12px;line-height:1.45;color:#4a4a4a;font-weight:500;overflow-wrap:break-word;word-break:break-word;align-self:flex-start;}.bb-drs-track{transition:height .18s ease;align-items:flex-start;}.bb-drs-nav{flex:0 0 auto;width:22px;border:0;background:none;padding:0;margin:0;cursor:pointer;color:#B34518;font-size:19px;line-height:1;font-weight:700;border-radius:6px;-webkit-user-select:none;user-select:none;}.bb-drs-nav:hover{background:rgba(235,103,60,.10);}.bb-drs-nav:active{background:rgba(235,103,60,.18);}.bb-drs-w{display:block;font-size:10.5px;color:#888;margin-top:3px;font-weight:600;}.bb-pt-r--us:checked~.bb-pt-seg .bb-pt-opt--us{background:#EB673C;color:#fff;}.bb-pt-r--us:checked~.bb-pt-body--us{display:block;}.bb-pt-r--them:checked~.bb-pt-seg .bb-pt-opt--them{background:#5f6368;color:#fff;}.bb-pt-r--them:checked~.bb-pt-body--them{display:block;}';document.head.appendChild(_bbds);}catch(e){}} if(!window.__bbDtogInit){window.__bbDtogInit=1;try{document.addEventListener('change',function(_ev){var _t=_ev.target;if(_t&&_t.classList&&_t.classList.contains('bb-pt-r')){var _mm=String(_t.id||'').match(/^bbpt-(us|them)-(.+)$/);if(_mm){window.__bbDtog=window.__bbDtog||{};window.__bbDtog[_mm[2]]=_mm[1];}}});}catch(e){}} var _dpShowR = _belowMin ? _dpT[0].rate : _dpR;
          // Always "for" (owner 2026-07-31). The rate card is FLAT — $49 / $149 everywhere — so
          // there is no range to hedge with "from", and "from" reads as "it could be more".
          // Restore the _belowMin ternary here if a banded/zoned card ever comes back.
          var _dpFW = 'for';
          /* ⭐ MIXED BREAKDOWN 2026-10-16 — see _mixed_breakdown.mjs. Same tables as getShipDates. */
          function _bbLaneWin(crane){
            try{
              var _zn = ZONES[geoState];
              if (_zn && typeof bbIsNewZone === 'function' && bbIsNewZone(_zn)) {
                var _t = crane
                  ? (typeof ZONE_ETA_C !== 'undefined' ? ZONE_ETA_C[_zn] : (typeof ZONE_ETA !== 'undefined' ? ZONE_ETA[_zn] : null))
                  : (typeof ZONE_QS_ETA !== 'undefined' ? ZONE_QS_ETA[_zn] : null);
                if (_t && _t.length > 1) return _t;
              }
              if (typeof _LT !== 'undefined' && _LT[geoState]) {
                var _z = _LT[geoState];
                return crane ? [_z[0], _z[1]] : [_z[2], _z[3]];
              }
            }catch(e){}
            return null;   /* ⛔ no window rather than a guessed one */
          }
          function _bbWk(w){ return (w && w.length > 1) ? (Math.round(w[0]/5) + '\u2013' + Math.round(w[1]/5) + ' wks') : ''; }
          var _dpBreak = '';
          /* ⭐ "$149 + $199" instead of "$348" — same money, read as two deliveries rather than a
             surcharge. Empty on a single-lane cart, which keeps its single figure. */
          var _mixPairTxt = '';
          try {
            if (bbCartMixedNow()) {
              var _zq = ZONES[geoState];
              var _lr = (RATES[_zq] && RATES[_zq][0]) ? RATES[_zq][0].rate : null;
              var _hr = (CRANE_RATES[_zq] && CRANE_RATES[_zq][0]) ? CRANE_RATES[_zq][0].rate : null;
              if (_lr !== null && _hr !== null) {
                /* ⭐ same function the "Arrives in ..." line uses, lane forced — never a second date path */
                var _lw = '', _hw = '';
                try { var _dL = getShipDates(null, 'q'); if (_dL && _dL.arrive) _lw = _dL.arrive; } catch(e){}
                try { var _dH = getShipDates(null, 'c'); if (_dH && _dH.arrive) _hw = _dH.arrive; } catch(e){}
                /* ⛔ Tier block REMOVED 2026-10-26 (owner: "get rid of this its chaos"). The card
             states the one rate that applies; the ladder lives on the shipping page and llms.txt. */
          try {
                  var _lvP = ((window.__bbCartLaneValues || {}).light) | 0,
                      _hvP = ((window.__bbCartLaneValues || {}).heavy) | 0;
                  var _pickP = function (t, cents) { var r = t[0].rate; for (var i = 0; i < t.length; i++) if (cents >= t[i].min) r = t[i].rate; return r; };
                  var _lrP = (RATES[_zq] && RATES[_zq].length) ? _pickP(RATES[_zq], _lvP) : _lr;
                  var _hrP = (CRANE_RATES[_zq] && CRANE_RATES[_zq].length) ? _pickP(CRANE_RATES[_zq], _hvP) : _hr;
                  _mixPairTxt = (_lrP === 0 ? 'FREE' : money(_lrP)) + ' + ' + (_hrP === 0 ? 'FREE' : money(_hrP));

                } catch (e) {}
              }
            }
          } catch(e){}
          /* ⛔⛔ THE PDP NEVER SAID THERE IS A FLOOR. The rail's left cap carried it and the rail
             was pulled today, so a $300 cart could see a delivery price for an order checkout
             will refuse. Reuses the same in-between slot: empty on a single-lane cart, and a
             mixed cart keeps its breakdown because the ladder explains the price it can see.
             ⛔ Gap rounds UP — money() floors, which would name a gap a dollar short of the floor
                and leave the shopper blocked after doing exactly what they were told. */
          /* ⛔⛔ THE MINIMUM WINS OVER THE BREAKDOWN. First written as "only if the slot is free",
             which meant a MIXED cart under the floor — the owner's own $326 cart — showed
             "Light $149 + Heavy $199 · pick one to save $149" and never the blocker. A rate the
             store will refuse must not outrank the reason it will refuse it. */
          try {
            if (_belowMin && _dpMin > 0) {
              var _minGap = Math.ceil((_dpMin - cartTotal) / 100) * 100;
              /* ⭐ the rate token already states the floor, so this line carries the ACTION.
                 On an empty cart there is no gap to close, so it states the rule instead. */
              _dpBreak = '<span style="display:block;margin:1px 0 2px;font-size:11.5px;font-weight:600;opacity:.9">'
                + ((cartTotal > 0 && _minGap > 0)
                    ? ('add <span style="color:#EB673C;font-weight:800">' + money(_minGap) + '</span> to unlock delivery')
                    : ('orders start at <span style="color:#EB673C;font-weight:800">' + money(_dpMin) + '</span>'))
                + '</span>';
            }
          } catch (e) {}
          /* ⭐ THE REMAINING LADDER, one line (owner: "Drops to $148 at $2,500 · FREE at $5,000").
             Read off the same tier table the headline prices from, so Light-only, Heavy-only and
             mixed each print their own figures and the mixed pair sums to the number above it.
             Only bands AHEAD of this cart, and only where the rate actually falls — past $2,500
             it reduces to the free tier, past $5,000 it disappears.
             ⛔ Silent below the minimum: the slider owns that state. */
          try {
            if (!_belowMin) {
              var _ndParts = [], _ndPrev = _dpR;
              for (var _ndI = 0; _ndI < _dpT.length; _ndI++) {
                if (_dpT[_ndI].min > cartTotal && _dpT[_ndI].rate < _ndPrev) {
                  _ndParts.push(_dpT[_ndI].rate === 0
                    ? ('<span style="color:#EB673C;font-weight:800">FREE</span> at ' + (money(_dpT[_ndI].min) + '+'))
                    : ('Drops to <span style="color:#EB673C;font-weight:800">' + money(_dpT[_ndI].rate) + '</span> at ' + (money(_dpT[_ndI].min) + '+')));
                  _ndPrev = _dpT[_ndI].rate;
                }
              }
              if (_ndParts.length) {
                _dpBreak = '<span style="display:block;margin:1px 0 2px;font-size:11.5px;font-weight:600;opacity:.85">'
                  + _ndParts.join(' &middot; ') + '</span>';
              }
            }
          } catch (e) {}
          /* ⭐ ONE-LINE FREE MESSAGE (owner 2026-10-28: "is there any way to one line free
             shipping without the slider?"). Replaces the ~64px slider with ~16px of text, rendered
             inside the delivery row directly beneath the rate — the rate and the way to remove it
             read as one thought.
             ⭐ THE THRESHOLD IS DERIVED from the first zero-rate band in the live tier table, so a
                reprice moves it and there is no $5,000 typed anywhere here.
             ⛔ Silent below the order minimum: down there the blocker is the $500 floor, which the
                row already states, and a free-delivery nudge would be answering the wrong question. */
          _dpBreak = '';
          var _dpFreeTail = '';
          try {
            if (!_belowMin) {
              var _fAt = 0;
              for (var _fi = 0; _fi < _dpT.length; _fi++) {
                if (+_dpT[_fi].rate === 0 && _dpT[_fi].min > 0) { _fAt = _dpT[_fi].min; break; }
              }
              if (_fAt > 0 && _fAt > cartTotal) {
                /* inline tail on the rate line, not its own row (owner 2026-10-28) */
                _dpFreeTail = ' &middot; <span style="color:#111111;font-weight:800">Free '
                  + '<span style="color:#EB673C">' + money(_fAt) + '+</span></span>';
              }
            }
          } catch (e) {}
          var _bbSvc = 'Delivered & Unloaded'; /* ⛔ ONE LANE (2026-11-01): Mixed/Heavy/Light all billed $99 from a single profile, so three labels for one rate is a distinction the customer cannot act on. */ /* ⛔ NO LONGER TRUNCATED (owner 2026-11-01). This stripped "Residential " whenever the free tail showed, so the row read "Delivery · $99 · Free $2,500+" — the owner asked for the full name. The ~36ch mobile budget is still real; the free tail is what gives way, not the name. */ /* 2026-10-30: 3-segment row busts the ~36ch mobile budget; shorten ONLY when the free tail shows. */ var _bbEtaLn = '<span class="bb-ship-allin__etaline" style="display:block;margin:0 0 11px;font-size:12px;font-weight:600;">Arrives' + (locationStr ? ' in ' + locationStr : '') + ' · <span class="bb-ship-allin__eta">' + _etaStr + '</span> · <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>';
          var _dpToggle = '<span class="bb-pt">' + '<input type="radio" name="bbpt-' + ctx + '" id="bbpt-us-' + ctx + '" class="bb-pt-r bb-pt-r--us"' + ((window.__bbDtog&&window.__bbDtog[ctx])==='them'?'':' checked') + '>' + '<input type="radio" name="bbpt-' + ctx + '" id="bbpt-them-' + ctx + '" class="bb-pt-r bb-pt-r--them"' + ((window.__bbDtog&&window.__bbDtog[ctx])==='them'?' checked':'') + '>' + '<span class="bb-pt-seg"><label for="bbpt-us-' + ctx + '" class="bb-pt-opt bb-pt-opt--us">Delivery</label><label for="bbpt-them-' + ctx + '" class="bb-pt-opt bb-pt-opt--them">Reviews</label></span>' + '<span class="bb-pt-body bb-pt-body--us"><strong style="display:block;margin-bottom:7px;font-size:12.5px;line-height:1.35">\uD83D\uDE9A ' + _bbSvc + (_belowMin ? ' \u00b7 ' : ' for ') + '<span class="bb-ship-allin__ratetoken">' + (_belowMin ? (money(_dpMin) + ' Order Minimum') : (_dpShowR === 0 ? 'Free' : money(_dpShowR))) + '</span>' + _dpFreeTail + '</strong>' /* ⛔ free tail removed from the row 2026-11-01: "for $99 Flat · Free $2,500+" is 304px against ~295px and wrapped. The threshold still shows on the price line, in the FAQ and at checkout. */ + _dpBreak + _dpTrust + '</span>' + _bbDrsPanel() + '</span>';
          var _dpDelivered = _belowMin
            // Below the minimum: the RAIL states the floor on its left cap ("$500 / minimum"), so
            // repeating it in a sentence is the same fact twice. Branch kept, not merged: down here
            // _dpR is 0 and _dpFree is false, so the chasing test would fall through to the
            // free-state line and wrongly print "Residential Delivery for FREE".
            ? _dpToggle
            : _dpToggle;   /* ⭐ ALWAYS the comparison (owner 2026-10-28). It used to vanish on a free cart,
                   which is the one cart where "they charge ~$199, we charge nothing" IS the argument. */
          // Empty cart: suppress the price + "all-in before discounts" cap (nothing
          // in the cart, no "$0 all-in") — show ONLY the nudge + ETA + change.
          /* ⛔⛔ BELOW THE FLOOR COUNTS AS "NO DELIVERY", NOT AS "DELIVERY INCLUDED". This branched
             on _emptyCart alone, so a $326 cart printed its own total under the words "includes
             delivery & unloading" — while the slider immediately beneath it said "$500 to go / to
             unlock delivery". One card, two contradictory claims, and the false one was the big
             number. Under the floor _dpR is 0, so nothing was being included at all.
             ⭐ Below the minimum we now show the cart total and CALL it the cart total; only once
                delivery actually applies does the label claim to include it. */
          var _dpPriceCap = (_emptyCart || _belowMin) ? ('<span class="bb-ship-allin__price">' + money(_emptyCart ? 0 : cartTotal) + '</span>' + '<span class="bb-ship-allin__cap">cart total</span>') : ('<span class="bb-ship-allin__price">' + money(cartTotal + _dpR) + '</span>' + '<span class="bb-ship-allin__cap">includes delivery &amp; unloading</span>');
          // Money stack (owner 2026-07, ported from USA): price -> Interac second
          // price -> merged delivery/nudge line + ETA + change (price/cap dropped on empty cart).
          // TIER STRIP (owner 2026-10-26, replacing "Pill on rail"). Rendered here, inside
          // _dpHero, because the estimator repaints this container and would wipe an injected node.
          //   one equal segment per DISTINCT rate; the active one is filled. Derived, never hardcoded.
          // Caps DERIVED: _dpMin (_dpT[0].min) and _dpFreeAt (first tier rate===0). Never hardcode.
          var _dpProg = '';
          // Renders on an EMPTY cart too (owner 2026-08-01) — that is the state a first-time
          // visitor lands in, and the offer has to be visible to the people it is meant to recruit.
          // ⭐ 2026-10-26: the proportional rail is now an EQUAL-SEGMENT TIER STRIP. At $0 the first
          // segment is simply the active one, so there is no percentage to floor and nothing to clamp.
          // ⭐ RAIL VALUE GATE (owner 2026-09-30, to shorten the PDP). The rail is ~110px — the tallest
          // single element in the card — and in Zone 1 it argues AGAINST the sale: "spend $1,426 more
          // to save $99". It only earns its height where the free tier is worth real money.
          //   _belowMin  -> ALWAYS show. Below $500 the rail is not an upsell, it is the ORDER
          //                 MINIMUM, a checkout blocker, and its left cap is where that is stated.
          //   _dpR       -> the delivery rate this cart would avoid, in CENTS. Reading the live rate
          //                 instead of the zone id means it self-adjusts per zone AND per lane
          //                 (loose vs crane) with no zone table to keep in sync.
          // At 24900 the rail shows for Z3/Z4 ($249-$399) and hides for Z1/Z2 ($49-$199) and for
          // carts already free (_dpR is 0 there, and the delivery line already reads FREE).
          /* ⛔ WAS `_railMinValue = 24900`, WHICH THE FLAT CARD MADE UNREACHABLE (owner
             2026-10-04: "I need the free over $5,000 one also"). _dpR is 14900 on every cart
             now, so `_dpR >= 24900` was never true and the rail only ever rendered through
             _belowMin — the "$500 minimum" version. 24900 was calibrated for the FOUR-ZONE
             card, where Z3/Z4 were $249-$399.
             ⭐ Derived from the LIVE rate, not a fresh constant: the rail earns its ~110px
                wherever the cart is below the minimum, or there is a real rate to avoid AND a
                free tier to reach. Nothing is pinned to 149, so a reprice cannot kill it again. */
          /* ⛔ RAIL RETIRED 2026-10-05. Both of its caps became false with the four-band card:
             there is no $500 order minimum and no free-over-$5,000 tier. Gated off here rather
             than deleted, so restoring it is one line if a free tier ever returns. */
          var _railWorth = (cartTotal < _dpMin) || (_dpR > 0 && _dpFreeAt > _dpMin);
          if (_railWorth && (cartTotal < _dpMin || _dpFreeAt > _dpMin)) {
            // TWO-STAGE (owner 2026-08-01): below the order minimum the rail targets the
            // MINIMUM, not FREE — that is the milestone actually blocking the shopper. It
            // re-targets to FREE the moment $500 is crossed. One decision, read by everything below.
            /* ⭐ TARGET THE NEXT MILESTONE, NOT ONLY FREE (owner 2026-10-26). The ladder has TWO
               drops now — $149 -> $49 at $1,000, then FREE at $3,500 — and a rail that only ever
               marked FREE hid the nearer, far more winnable one. DERIVED from the live tier table,
               so a reprice moves it with no constant to maintain. */
            var _dpNextAt = 0, _dpNextRate = -1;
            for (var _ni = 0; _ni < _dpT.length; _ni++) {
              if (_dpT[_ni].min > cartTotal && _dpT[_ni].rate < _dpR) {
                _dpNextAt = _dpT[_ni].min; _dpNextRate = _dpT[_ni].rate; break;
              }
            }
            var _rStage1 = cartTotal < _dpMin;
            /* ⭐ SLIDER v2, owner spec 2026-10-26: left cap = $0 (cart), right cap = $3,500+,
               interior tick = cart value over the rate there, pill = gap + the current rate struck
               through to the next one. Pill ABOVE the bar, tick label BELOW — that separation is
               why they no longer collide. */
            /* ⛔⛔ SCALE IS WHY THIS WAS UNREADABLE. On one $0-$5,000 axis a $326 cart put the
               truck at 6% and the $500 gate at 10%, so the only two things that mattered shared the
               first tenth of the bar. Stage 1 spans $0 -> the floor; stage 2 rebases to
               floor -> free. One question per stage. */
            var _rLo = _rStage1 ? 0 : _dpMin;
            var _rHi = _rStage1 ? _dpMin : (_dpFreeAt || _dpNextAt || _dpMin);
            var _dpSpan = Math.max(1, _rHi - _rLo);
            var _dpPct = _dpFree ? 100 : Math.max(2, Math.min(98, Math.round((cartTotal - _rLo) / _dpSpan * 100)));
            var _dpLblPct = Math.max(12, Math.min(86, _dpPct));
            var _dpRightAlign = _dpPct > 80;
            var _dpAnchor = _dpRightAlign
              ? ('right:' + (100 - _dpLblPct) + '%;transform:translateX(12px)')
              : ('left:' + _dpLblPct + '%;transform:translateX(-50%)');
            /* ⛔ STAGE ONE TARGETS THE FLOOR. Below the minimum _dpR is 0, so the "next cheaper tier"
               search can never match and the pill fell through to the far cap — a $326 cart was told
               "$4,674 to go" when $174 was what actually unblocked it. */
            var _dpNextMs = _rStage1 ? _dpMin : ((_dpNextAt > cartTotal) ? _dpNextAt : _rHi);
            var _dpGapTxt = money(Math.ceil(Math.max(0, _dpNextMs - cartTotal) / 100) * 100);
            var _dpBecomes = (_dpNextRate === 0 || _dpNextRate === -1) ? 'FREE' : money(_dpNextRate);
            var _dpCaret = _dpRightAlign ? '' : '<span style="position:absolute;top:100%;left:50%;transform:translateX(-50%);width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #EB673C"></span>';
            /* two lines: the ask, then the rate it buys — current struck, next in full */
            /* ⭐ SPLIT PILL (owner 2026-10-28: "move one line above and one below slider so we can
               save some room"). ABOVE = the ask. BELOW = what this cart pays now and what it
               becomes. Two single-line labels need far less vertical gutter than one stacked
               pill, and the space under the bar was empty under a flat card. */
            var _dpPill = _dpFree ? '' : '<span style="position:absolute;bottom:calc(100% + 8px);' + _dpAnchor + ';white-space:nowrap;color:#FFFFFF;background:#EB673C;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:800;line-height:1.2;box-shadow:0 1px 3px rgba(0,0,0,0.18)">'
              + _dpGapTxt + ' to go'
              + _dpCaret + '</span>';
            /* ⛔ Sits BELOW the bar, at the same horizontal anchor as the pill. Under a flat card
               the interior-tick loop emits nothing, so this row is unoccupied — see the header. */
            var _dpUnder = _dpFree ? '' : '<span style="position:absolute;top:calc(100% + 6px);' + _dpAnchor + ';white-space:nowrap;font-size:10.5px;font-weight:800;line-height:1.2;color:#EB673C">'
              + (_rStage1
                  ? 'to unlock delivery'
                  : ('<span style="text-decoration:line-through;opacity:0.5;color:#111111">' + (_dpR > 0 ? money(_dpR) : '') + '</span> \u2192 ' + _dpBecomes))
              + '</span>';

            /* interior ticks: every distinct-rate boundary except the first and the last */
            var _ivSegs = [];
            for (var _si = 0; _si < _dpT.length; _si++) {
              if (!_ivSegs.length || _dpT[_si].rate !== _ivSegs[_ivSegs.length - 1].rate) {
                _ivSegs.push({ min: _dpT[_si].min, rate: _dpT[_si].rate });
              }
            }
            var _ivTicks = '';
            /* ⭐ start at 0 when the first band begins ABOVE the rail's left cap — that boundary is the
               ORDER MINIMUM, the one milestone a short cart can act on. Skipping index 0 was correct
               only while band one started at zero. */
            for (var _sk = (_ivSegs.length && _ivSegs[0].min > _rLo) ? 0 : 1; _sk < _ivSegs.length - 1; _sk++) {
              /* ⛔ a milestone outside this stage would be drawn at 500% and pile onto the cap */
              if (_ivSegs[_sk].min <= _rLo || _ivSegs[_sk].min >= _rHi) continue;
              var _tPct = Math.max(4, Math.min(94, Math.round((_ivSegs[_sk].min - _rLo) / _dpSpan * 100)));
              var _tOn = cartTotal >= _ivSegs[_sk].min;
              _ivTicks +=
                '<span style="position:absolute;top:-4px;left:' + _tPct + '%;width:2px;height:18px;background:#EB673C;opacity:' + (_tOn ? '0.85' : '0.45') + ';transform:translateX(-50%);border-radius:1px"></span>' +
                '<span style="position:absolute;bottom:calc(100% + 4px);left:' + _tPct + '%;transform:translateX(-50%);font-size:10px;font-weight:800;white-space:nowrap;line-height:1.2;color:#111111;opacity:0.6">' + money(_ivSegs[_sk].min) + '</span>' +
                '<span style="position:absolute;top:calc(100% + 3px);left:' + _tPct + '%;transform:translateX(-50%);font-size:11px;font-weight:800;white-space:nowrap;line-height:1.2;color:#EB673C">' + (_sk === 0 ? 'min' : (_ivSegs[_sk].rate === 0 ? 'FREE' : money(_ivSegs[_sk].rate))) + '</span>';
            }

            _dpProg = '<span class="bb-ship-allin__label bb-ship-rail" style="display:block;position:sticky;top:0;z-index:6;background:#FFFFFF;margin:0 -2px 4px;box-shadow:0 2px 6px -4px rgba(0,0,0,0.35);padding-top:' + (_dpFree ? '2px' : '21px') + ';padding-bottom:' + (_dpFree ? '2px' : '26px') + '">' +
              '<span style="display:flex;align-items:center;gap:8px">' +
                '<span style="font-size:11px;font-weight:800;flex:0 0 34px;text-align:right;line-height:1.2;color:#111111;opacity:0.55">' + money(_rLo) + '</span>' +
                '<span style="position:relative;flex:1 1 auto;height:8px;border-radius:99px;background:rgba(0,0,0,0.13)">' +
                  '<span style="display:block;height:100%;width:' + _dpPct + '%;border-radius:99px;background:' + (_dpFree ? '#EB673C' : 'linear-gradient(90deg,#F4A57F,#EB673C)') + '"></span>' +
                  _ivTicks +
                  '<span style="position:absolute;top:50%;left:' + _dpPct + '%;transform:translate(-50%,-50%);font-size:13px;line-height:1;filter:drop-shadow(0 0 2px #FFFFFF) drop-shadow(0 1px 2px rgba(0,0,0,0.35))">\uD83D\uDE9A</span>' +
                  _dpPill +
                  _dpUnder +
                '</span>' +
                '<span style="font-size:11px;font-weight:800;flex:0 0 44px;position:relative;line-height:1.25;text-align:left;color:#111111;opacity:0.7">' + money(_rHi) + (_rStage1 ? '' : '+') +
                  '<span style="position:absolute;top:100%;left:50%;transform:translateX(-50%);margin-top:3px;white-space:nowrap;font-size:10.5px;font-weight:800;color:' + (_dpFree ? '#FFFFFF' : '#EB673C') + ';background:' + (_dpFree ? '#EB673C' : 'transparent') + ';border-radius:99px;padding:' + (_dpFree ? '1px 6px' : '0') + ';opacity:1">' + (_rStage1 ? 'Order Minimum' : 'FREE') + (_dpFree ? ' \u2713' : '') + '</span></span>' +
              '</span></span>';
          }

          /* ── three savings toggles: freight · speed · product (owner 2026-08-16) ──
             Self-contained and wrapped: a throw here must never cost the panel its price. */
          var _bbTogs = '';
          try {
            if (!_emptyCart) {
              var _tI  = (_dpI >= 0) ? _dpI : 0;
              var _tQS = (RATES[geoZone] && RATES[geoZone][_tI]) ? RATES[geoZone][_tI].rate : 0;
              var _tCR = (CRANE_RATES[geoZone] && CRANE_RATES[geoZone][_tI]) ? CRANE_RATES[geoZone][_tI].rate : 0;
              var _tQSn = '', _tCRn = '';
              /* __bbCartLanes is the same source bbCartMixedNow() reads, so the three toggles and
                 the rate line above can never disagree about what is in the cart. */
              var _tL = (window.__bbCartLanes || {});
              var _tMix = !!(_tL.loose && _tL.crane);
              var _tCraneOnly = !!(_tL.crane && !_tL.loose);
              /* Real DATES, never "weeks" (owner). Both lanes go through getShipDates(), which is
                 the SAME function the headline ETA uses — so a lane window can never disagree with
                 the ETA above it, and zone overrides / special-order both still apply. ⛔ Do not
                 recompute dates from _LT here: that would be a second copy of the lead-time model,
                 and Extended zones override it.
                 "Same window" is decided by comparing the two rendered ranges, so Canada's standard
                 provinces (crane and loose both 14–28d) report the truth without a hardcoded rule. */
              var _tDq = getShipDates(geoZone, 'q');
              var _tDc = getShipDates(geoZone, 'c');
              /* ⛔ THE TWO STORES RETURN DIFFERENT SHAPES. Canada's getShipDates returns a
                 "range" key ("Aug 29 – Sep 12"); the USA one has no such key and carries the same
                 string in "arrive". Reading only .range printed "arrives undefined" live on USA
                 while the stubbed test stayed green. Take whichever this store provides.
                 (No backticks in here — this block is injected through a template literal.) */
              var _tLw = (_tDq.range || _tDq.arrive), _tCw = (_tDc.range || _tDc.arrive);
              var _tSame = (_tLw === _tCw);
              /* Owner: "black text larger and bold". The panel copy was hard to read at 11px/.75
                 grey. Full-black #1A1A1A, 13px, weight 600 — no opacity dimming, which is what
                 made it look washed out. The BUTTONS stay 11px: they must fit three across in the
                 ~340px slide cart, and that is the only place width is tight. */
              /* Owner: "too big or bold in the drop down · keep it short and condensed."
                 11px / weight 400, with 600 reserved for the ✓ confirmations only. The dollar
                 amounts carry <strong>, so emphasis lands on the numbers instead of the sentence. */
              var _tMut = 'display:block;text-align:center;color:#1A1A1A;font-size:11px;line-height:1.45;font-weight:400;';
              var _tWin = 'display:block;text-align:center;color:#1A1A1A;font-size:11px;line-height:1.45;font-weight:600;';

              /* Condensed (owner). Accent carries the payoff figure; the sentence stays plain. */
              var _tAcc = 'color:#B34518;font-weight:700;';   /* #EB673C fails contrast as text */
              var _tOk = '<span style="color:#1E7A4B;font-weight:700;">✓</span> ';
              /* 1 ── freight */
              var _tFrt;
              if (_dpFree) _tFrt = '<span style="' + _tWin + '">' + _tOk + 'Delivery is a <span style="' + _tAcc + '">flat rate</span> for your zone.</span>';
              else if (_belowMin) _tFrt = '<span style="' + _tMut + '">Orders start at <span style="' + _tAcc + '">' + money(50000) + '</span>.</span>';
              else if (_tMix) _tFrt = '<span style="' + _tMut + '">Both lanes are charged:</span>' +
                '<span style="' + _tMut + '">' + _tQSn + ' only <span style="' + _tAcc + '">' + money(_tQS) + '</span> · saves ' + money(_tCR) + '</span>' +
                '<span style="' + _tMut + '">' + _tCRn + ' only <span style="' + _tAcc + '">' + money(_tCR) + '</span> · saves ' + money(_tQS) + '</span>';
              else if (_tCraneOnly) {
                /* Two stacked lines, mirroring the speed block below. The saving is stated
                   because the panel is titled "Save on Freight" — owner 2026-09-17:
                   "save on freight in the PDP formatting a bit confusing". */
                /* Owner 2026-09-17: "its quite busy" / "we dont need to say unframed" / "or
                   save $50" — so two bare lines, lane and price, nothing else. */
                _tFrt = '<span style="' + _tMut + '">' + _tCRn + ' &mdash; <span style="' + _tAcc + '">' + money(_tCR) + '</span></span>' +
                  '<span style="' + _tWin + '">' + _tQSn + ' &mdash; <span style="' + _tAcc + '">' + money(_tQS) + '</span></span>';
              }
              else _tFrt = '<span style="' + _tWin + '">' + _tOk + 'Lowest freight already — <span style="' + _tAcc + '">' + money(_tQS) + '</span></span>';
              if (!_belowMin && !_dpFree && _dpChasing && _dpShort > 0) {
                /* ⭐ FREE-DELIVERY PROGRESS BAR (2026-09-18) — the "PDP slider" pushing to free
                   shipping. Rendered here because _dpShort / _dpFreeAt / cartTotal are already
                   computed and the nudge text already lands here; the standalone
                   bb-free-progress.js asset is orphaned (no loader, no mount points).
                   ⛔ Use display:block SPAN elements only. This string is appended inside a SPAN,
                      so a DIV element here is invalid markup and the browser hoists it out of its
                      container, stranding the bar elsewhere on the page. */
                var _pct = (_dpFreeAt > 0) ? Math.max(0, Math.min(100, (cartTotal / _dpFreeAt) * 100)) : 0;
                _tFrt += '<span style="' + _tMut + 'margin-top:3px;">Add <span style="' + _tAcc + '">' + money(Math.ceil(_dpShort / 100) * 100) + '</span> for free delivery</span>'
                  + '<span style="display:block;height:6px;border-radius:99px;background:rgba(0,0,0,.10);overflow:hidden;margin-top:6px;">'
                  +   '<span style="display:block;height:100%;width:' + _pct.toFixed(1) + '%;border-radius:99px;background:#EB673C;transition:width .45s ease;"></span>'
                  + '</span>';
              }

              /* 2 ── speed */
              var _tSpd;
              if (_tSame) _tSpd = '<span style="' + _tWin + '">' + _tOk + 'All lanes arrive <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              else if (!_tMix && !_tCraneOnly) _tSpd = '<span style="' + _tWin + '">' + _tOk + 'Fastest lane already — <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              /* Owner: on a MIXED cart, recommend the Loose Truck explicitly. A mixed cart travels
                 at the SLOWER lane, so naming both dates is the whole argument. */
              else if (_tMix) _tSpd = '<span style="' + _tMut + '">Mixed ships at the slower lane · ' + _tCw + '</span>' +
                '<span style="' + _tWin + '">' + _tQSn + ' items alone arrive <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              else _tSpd = '<span style="' + _tMut + '">' + _tCRn + ' · ' + _tCw + '</span>' +
                '<span style="' + _tWin + '">Unframed ships ' + _tQSn + ' · <span style="' + _tAcc + '">' + _tLw + '</span></span>';

              /* 3 ── product. _dpDisc/_dpPay are in scope HERE and not earlier — see header. */
              /* Lead with the SAVING, not just the landed total — the shopper should not have to
                 subtract to see what the discount is worth. Same convention as the savings strip
                 above the panel, which states the dollar amount rather than only the percentage.
                 Both figures derive from cartTotal so they cannot disagree with it. */
              var _tPrd = '';
              if (_dpDisc > 0) _tPrd += '<span style="' + _tMut + '">Pay by ' + _dpPay + ' · save <span style="' + _tAcc + '">' + money(Math.round(cartTotal * _dpDisc)) + '</span> &rarr; <span style="' + _tAcc + '">' + money(Math.round(cartTotal * (1 - _dpDisc)) + _dpR) + '</span> all-in</span>';
              if (window.BB_BUCKS && window.BB_BUCKS.enabled && typeof window.BB_BUCKS.rate === 'number' && window.BB_BUCKS.rate > 0)
                _tPrd += '<span style="' + _tMut + '">Plus <span style="' + _tAcc + '">' + money(Math.round(cartTotal * window.BB_BUCKS.rate)) + '</span> back in BarrierBucks</span>';

              /* Side by side (owner): the three buttons sit in one flex row and the panels render
                 BELOW it at full width. That rules out sibling traversal — a panel is no longer
                 adjacent to its button — so each button finds its panel by class, scoped with
                 closest('.bb-ship-togs'). ⛔ An unscoped document.querySelector would hit the
                 PDP's copy from inside the cart drawer: the same markup renders in all three
                 contexts. Opening one closes the others — three panels open at once in a ~380px
                 column pushes the price off a phone screen. */
              var _tBtn = function (id, label, body) {
                if (!body) return '';
                return '<button type="button" aria-expanded="false" data-bb-tog="' + id + '" onclick="' +
                  'var r=this.closest(\'.bb-ship-togs\');' +
                  'var me=r.querySelector(\'.bb-tog-\'+this.getAttribute(\'data-bb-tog\'));' +
                  'var o=me.style.display===\'none\';' +
                  'r.querySelectorAll(\'[class^=bb-tog-]\').forEach(function(p){p.style.display=\'none\';});' +
                  'r.querySelectorAll(\'[data-bb-tog]\').forEach(function(b){b.setAttribute(\'aria-expanded\',\'false\');var c=b.querySelector(\'[data-bb-caret]\');if(c)c.textContent=\'▾\';});' +
                  'if(o){me.style.display=\'block\';this.setAttribute(\'aria-expanded\',\'true\');var c2=this.querySelector(\'[data-bb-caret]\');if(c2)c2.textContent=\'▴\';}" ' +
                  'style="background:none;border:0;padding:0;margin:0;cursor:pointer;font:inherit;font-size:11px;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:2px;display:inline-flex;align-items:center;gap:2px;white-space:nowrap;flex:0 1 auto;min-width:0;">' +
                  label + ' <span data-bb-caret style="font-size:9px;">▾</span></button>';
              };
              var _tPan = function (id, body) {
                return body ? '<span class="bb-tog-' + id + '" style="display:none;margin-top:6px;">' + body + '</span>' : '';
              };
              /* nowrap + space-between keeps all THREE on one line in the slide cart (~340px),
                 where flex-wrap:wrap was breaking them 2 + 1. Padding is tighter than the panel's
                 for the same reason — every pixel is width for the third label. */
              /* Measured in the live drawer: at 271px the three labels need 281px, so they were
                 being SHRUNK and clipped (scrollWidth > clientWidth on all three) rather than
                 wrapped — invisible in a screenshot, but the labels were losing their last pixels.
                 Reclaiming 12px from gap (8->4) and padding (10->8) clears the 10px shortfall
                 without touching the type size. */
              /* Owner: "a bit of a background hue". Faint warm tint keyed to the brand accent —
                 the same family as the orange delivery box above, at a fraction of the strength so
                 it reads as a distinct section without competing with the price. */
              /* ⛔ OWNER 2026-09-26: the three toggles are REMOVED from the cart. Flip
                 BB_SHOW_SHIP_TOGS back to true to restore them — the builders and panel bodies
                 below are intentionally left intact so nothing else has to be rebuilt. */
              var BB_SHOW_SHIP_TOGS = false;
              if (BB_SHOW_SHIP_TOGS) _bbTogs = '<div class="bb-ship-togs" style="padding:9px 8px 10px;border-top:1px solid rgba(235,103,60,.18);background:rgba(235,103,60,.05);border-radius:0 0 10px 10px;text-align:center;">' +
                '<span style="display:flex;justify-content:space-between;align-items:center;gap:4px;flex-wrap:nowrap;">' +
                  _tBtn('frt', 'Save on Freight', _tFrt) + _tBtn('spd', 'Get it Quicker', _tSpd) + _tBtn('prd', 'Save on Product', _tPrd) +
                '</span>' +
                _tPan('frt', _tFrt) + _tPan('spd', _tSpd) + _tPan('prd', _tPrd) +
                '</div>';
            }
          } catch (_te) { _bbTogs = ''; }
          _dpHero = '<div class="bb-ship-allin' + (_dpFree ? ' bb-ship-allin--free' : '') + '">' +
            /* ⭐ ETA MOVED INSIDE THE DELIVERY BOX (owner 2026-09-30). It sat ABOVE the price, so the headline
               number was the fourth thing read. City, date and rate are one subject — one place. */
            '<span class="bb-ship-allin__label" style="margin-top:0"><span class="bb-ship-allin__dl">' + _bbEtaLn + '</span></span>' +
            _dpPriceCap + _dpHint +
            /* ⭐ SLIDER SITS UNDER THE BANK-DEPOSIT HINT AND ABOVE THE BARRIERBOSS/Others
               comparison (owner 2026-10-26). Order only — nothing is rebuilt. */
            /* ⛔ SLIDER REMOVED 2026-10-26 — the freight tiers now live inside the delivery box
               (see _dpBreak). Two surfaces stating the same ladder is what made the card messy. */
            '<span class="bb-ship-allin__label"><span class="bb-ship-allin__dl">' + _dpDelivered + '</span></span>' +
            _bbTogs +
            '</div>';
        }
      } catch (_e) {}
      { /* ⛔ 2026-10-16: the zone gate is GONE. It hid the card title everywhere outside the old west zones — a Florida or Ontario shopper saw an untitled card. The title is a brand statement, not a regional one. */
        homeownerBadge = '<div class="bb-ship-homeowner-badge" style="display:flex;align-items:center;gap:8px;margin-top:6px;font-size:10px;font-weight:600;color:#000;letter-spacing:0.8px;text-transform:uppercase;margin-bottom:0px;"><span style="flex:1;height:1px;background:rgba(0,0,0,0.15);"></span><span style="color:#EB673C;font-size:12px;">★</span><span style="text-align:center;"><span style="display:block;font-size:11px;font-weight:700;letter-spacing:1.2px;color:#333;white-space:nowrap;">Made, Moved &amp; Unloaded by Us</span><span class="bb-origin-badge" style="display:none;font-size:11px;font-weight:700;letter-spacing:1.2px;color:#333;white-space:nowrap;margin-top:3px;"><span style="font-size:13px;line-height:1;letter-spacing:0;">\uD83C\uDDE8\uD83C\uDDE6</span> Built in Canada</span></span><span style="color:#EB673C;font-size:12px;">★</span><span style="flex:1;height:1px;background:rgba(0,0,0,0.15);"></span></div>';
      }
      // CA-specific: keep the SPECIAL ORDER pill (CA has richer SO detection; the
      // USA build has none). Small + centered, above the hero — signal CA keeps.
      var _soPill = dates.isSpecialOrder ? '<div style="text-align:center;margin-bottom:6px;"><span class="bb-ship-so-pill" style="display:inline-block;padding:3px 10px;background:#fff3cd;color:#7a4a00;border:1px solid #f0ad4e;border-radius:3px;font-size:10px;font-weight:700;letter-spacing:0.6px;cursor:pointer;">SPECIAL ORDER</span></div>' : '';
      // Delivery line MERGED into the hero when it shows. Below $500 (no rate yet)
      // fall back to the standalone BARRIERBOSS Residential Delivery row so town/ETA/change
      // aren't lost.
      var _fallbackDelivery = '<div class="bb-ship-header__line"><span class="bb-ship-header__zone">BARRIERBOSS Residential Delivery · <span class="bb-ship-header__loc">' + locationStr + '</span> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span><span class="bb-ship-header__arrival">ETA <strong class="bb-ship-header__loc">' + _etaStr + '</strong></span></div>';
      headerEl.innerHTML = homeownerBadge + _soPill + _dpHero + (_dpHero ? '' : _fallbackDelivery);
    }

    var _trustEl = document.getElementById('bb-ship-trust-' + ctx);
    // BarrierBucks moved OUT of the estimator to its own cart-drawer card (owner
    // 2026-07, ported from USA) — avoids double-count with the standalone card.
    if (_trustEl) _trustEl.innerHTML = _subline + (ctx === 'product' ? '' : _trustBadges);

    // === DELIVERY — hidden (arrival moved to header) ===
    deliveryEl.style.display = 'none';

    if (!el.dataset.ga4Viewed) {
      el.dataset.ga4Viewed = '1';
      ga4Event('bb_estimator_view', {
        context: ctx, zone: geoZone, province: geoState, cart_total: cartTotal / 100
      });
    }

    // GA4: dates shown event (once per context)
    if (!el.dataset.ga4Dates) {
      el.dataset.ga4Dates = '1';
      ga4Event('bb_estimator_dates_shown', {
        context: ctx, zone: geoZone, province: geoState,
        ship_date: dates.ship, arrive_from: dates.arriveFrom, arrive_to: dates.arriveTo,
        transit_days: ZONE_TRANSIT_MAX[geoZone], cart_total: cartTotal / 100,
        current_rate: currentIdx >= 0 ? tiers[currentIdx].label : 'below_min'
      });
    }

    el.style.display = 'block';
    // Mutual exclusion: the estimator is now visible for this context, so hide
    // its postal-code fallback. Prevents the "estimator + postal bar double-up"
    // — a geo failure or drawer re-render could have revealed the fallback, and
    // nothing else hid it once geo later resolved (only a hard refresh did).
    // querySelectorAll guards against any duplicate fallback node in the drawer.
    var _zEls = document.querySelectorAll('[id="bb-ship-zip-' + ctx + '"]');
    for (var _zi = 0; _zi < _zEls.length; _zi++) _zEls[_zi].style.display = 'none';
  }

  // Track cart value decreases after estimator shown
  var lastCartTotal = 0;
  var estimatorWasShown = false;

  function renderAll(cartTotal) {
    renderElement('product', cartTotal);
    renderElement('cart', cartTotal);
    renderElement('cartpage', cartTotal);
    // Publish current shipping rate so a PDP fence calculator can show a
    // delivered material cost that includes freight (ported from USA; additive).
    try {
      // Same lane-aware rule as the notice: a Loose Truck cart into ON/QC/Maritimes must publish
      // a REAL rate so the PDP and FOB show it.
      // The Crane profile reaches only the Express zones. Where Loose Truck opened on 2026-08-12
      // crane did NOT, and CRANE_RATES has no entry there — so both branches below were skipped
      // and consumers kept displaying the PREVIOUS cart's rate. A stale number for an impossible
      // checkout is worse than silence.
      var _bbCraneUnreachable = !!(bbCraneNow() && geoZone && !bbCraneServed(geoZone));
      if (geoState && (UNSERVED_PROVINCES[geoState] || _bbCraneUnreachable || (bbCraneNow() && CRANE_PAUSED_PROVINCES[geoState]))) {
        document.dispatchEvent(new CustomEvent('bb:ship-rate', { detail: { rateCents: null, label: null, zone: geoZone, atFree: false, cartTotal: cartTotal, paused: true,
          craneBlocked: !!((_bbCraneUnreachable || (bbCraneNow() && CRANE_PAUSED_PROVINCES[geoState])) && !UNSERVED_PROVINCES[geoState]),
          quickShipAvailable: !!(ZONES[geoState] && !UNSERVED_PROVINCES[geoState]) } }));
      } else if (geoZone && bbRates()[geoZone]) {
        var _tiers = bbRates()[geoZone];
        var _idx = getCurrentTierIndex(geoZone, cartTotal);
        var _rateCents = (_idx >= 0 && _idx < _tiers.length) ? _tiers[_idx].rate : null;
        var _label = (_idx >= 0 && _idx < _tiers.length) ? _tiers[_idx].label : null;
        document.dispatchEvent(new CustomEvent('bb:ship-rate', { detail: { rateCents: _rateCents, label: _label, zone: geoZone, atFree: _rateCents === 0, cartTotal: cartTotal } }));
      }
    } catch(e) {}
  }

  function bindPdpVariantListener() {
    function onVariantSwitch() {
      var pdpSO = detectSpecialOrderFromPDP();
      // OR-merge with whatever the cart detection had
      hasSpecialOrderInCart = hasSpecialOrderInCart || pdpSO;
      // Force a fresh evaluation: detect from cart again so toggling back to a non-SO
      // mesh while cart is empty correctly clears the flag.
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        hasSpecialOrderInCart = detectSpecialOrder(cart.items) || detectSpecialOrderFromPDP();
        try {
          window.__bbCartCraneKnown = true;
          window.__bbCartItemCount = (cart.items || []).length;
          window.__bbCartLanes = bbCartLanes(cart.items);
          window.__bbCartCrane = bbCartHasCrane(cart.items);
        } catch (_e) {}
        renderAll(bbFreightCents(cart)); bbApplySampleOnly(cart);
      }).catch(function () {
        renderAll(0);
      });
    }
    var sels = document.querySelectorAll('select.single-option-selector');
    for (var i = 0; i < sels.length; i++) sels[i].addEventListener('change', onVariantSwitch);
    var section = document.querySelector('.js-product') || document.querySelector('.product-template');
    if (section) section.addEventListener('on:variant:change', onVariantSwitch);
    // First evaluation on page load
    onVariantSwitch();
  }
  var _bbRefreshTimer = null;
  // Debounce: coalesce rapid add/remove into ONE trailing refresh so concurrent
  // /cart.js reads can't land out of order and flicker an old total back in.
  function scheduleRefresh() {
    if (_bbRefreshTimer) clearTimeout(_bbRefreshTimer);
    _bbRefreshTimer = setTimeout(refreshFromCart, 300);
  }
  function refreshFromCart() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        hasSpecialOrderInCart = detectSpecialOrder(cart.items) || detectSpecialOrderFromPDP();
        try {
          window.__bbCartCraneKnown = true;
          window.__bbCartItemCount = (cart.items || []).length;
          window.__bbCartLanes = bbCartLanes(cart.items);
          window.__bbCartCrane = bbCartHasCrane(cart.items);
        } catch (_e) {}
        if (cart.items && cart.items.length > 0) {
          var totalQty = 0;
          for (var i = 0; i < cart.items.length; i++) totalQty += cart.items[i].quantity;
          if (totalQty > 0) avgItemPrice = Math.round(cart.total_price / totalQty);
        }
        // Track cart decreases after estimator was shown
        if (estimatorWasShown && lastCartTotal > 0 && cart.total_price < lastCartTotal) {
          ga4Event('bb_estimator_cart_decrease', {
            zone: geoZone, province: geoState,
            previous_total: lastCartTotal / 100,
            new_total: cart.total_price / 100,
            decrease: (lastCartTotal - cart.total_price) / 100
          });
        }
        if (geoZone) estimatorWasShown = true;
        lastCartTotal = cart.total_price;
        renderAll(bbFreightCents(cart)); bbApplySampleOnly(cart);
      })
      .catch(function() {});
  }

  function postalToProvince(postal) {
    if (!window.BBGeo) return null;
    var r = window.BBGeo.resolveCode(postal);
    return r ? r.region : null;
  }

  function resolveGeo(callback) {
    var cached = sessionStorage.getItem('bb_geo_state');
    var cachedCity = sessionStorage.getItem('bb_geo_city');
    if (cached && ZONES[cached]) {
      geoState = cached;
      // Only trust a cached city if THIS estimator validated it as belonging to
      // this CA province. bb_geo_city is a SHARED sessionStorage key that other
      // scripts (e.g. bb-dynamic-banner-ca.js) write from raw IP geo WITHOUT a
      // country check, so a non-CA city can land there. Mismatch => drop the
      // city and show the province only (never pair a foreign city with a CA
      // province).
      geoCity = (cachedCity && sessionStorage.getItem('bb_geo_city_ok') === (cached + '|' + cachedCity)) ? cachedCity : '';
      geoZone = ZONES[cached];
      callback();
      return;
    }
    if (!window.BBGeo) { showZipFallback(); return; }
    window.BBGeo.resolveIP(function (ip) {
      // ⛔ The CANADA gate stays here, in the CA consumer. BBGeo hands back a
      // region and a country; only this file knows that a US city must never
      // be paired with a CA province. Not clearly Canadian => postal prompt.
      var isCanada = ip && ip.country === 'CA';
      if (isCanada && ip.region && ZONES[ip.region]) {
        geoState = ip.region;
        geoCity = ip.city || '';
        geoZone = ZONES[ip.region];
        window.BBGeo.set({ region: geoState, city: geoCity, source: 'ip' }, { silent: true });
        callback();
      } else {
        showZipFallback();
      }
    });
  }

  // Inject a postal-code fallback UI into the slide-cart drawer if one doesn't exist
  // (the Liquid templates only render the fallback inside the PDP context).
  function injectCartZipFallback() {
    if (document.getElementById('bb-ship-zip-cart')) return;
    var drawer = document.getElementById('sidebar-cart')
              || document.querySelector('.Cart-Drawer')
              || document.querySelector('.cart-drawer')
              || document.querySelector('#CartDrawer');
    if (!drawer) return;
    var mount = drawer.querySelector('.Drawer__Main, .cart__form, form[action*="/cart"]') || drawer;
    var div = document.createElement('div');
    div.id = 'bb-ship-zip-cart';
    div.style.cssText = 'display:none;padding:12px 16px;background:#fff8e1;border-bottom:1px solid #f0ad4e;font-family:inherit;';
    div.innerHTML =
      '<div style="font-size:12px;font-weight:600;color:#7a4a00;margin-bottom:6px;">Enter your Postal Code for delivery estimate:</div>' +
      '<div style="display:flex;gap:6px;align-items:center;">' +
        '<input id="bb-ship-zip-input-cart" type="text" placeholder="Postal Code" autocomplete="postal-code" style="flex:1;padding:7px 10px;border:1.5px solid #f0ad4e;border-radius:3px;font-size:13px;outline:none;">' +
        '<button id="bb-ship-zip-btn-cart" type="button" style="padding:7px 14px;background:#EB673C;color:#fff;border:0;border-radius:3px;font-size:13px;font-weight:700;cursor:pointer;letter-spacing:0.3px;">Set</button>' +
      '</div>';
    mount.insertBefore(div, mount.firstChild);
  }

  function showZipFallback() {
    injectCartZipFallback();
    var els = document.querySelectorAll('[id^="bb-ship-zip-"]');
    for (var i = 0; i < els.length; i++) els[i].style.display = 'block';
    // Mutual exclusion (other direction): geo is unknown, so no estimator block
    // should remain visible alongside the postal fallback.
    var estEls = document.querySelectorAll('[id^="bb-ship-est-"]');
    for (var j = 0; j < estEls.length; j++) estEls[j].style.display = 'none';
  }

  function handleZipClick(e) {
    var btn = e.target;
    var ctx = btn.id.replace('bb-ship-zip-btn-', '');
    var input = document.getElementById('bb-ship-zip-input-' + ctx);
    var postal = (input.value || '').trim();
    var province = postalToProvince(postal);

    if (!province || !ZONES[province]) return;

    geoState = province;
    geoZone = ZONES[province];
    // Postal entry gives a province but no city — BBGeo.set with no city clears
    // the city and BOTH ownership stamps, so nothing stale can pair with it.
    geoCity = '';
    if (window.BBGeo) window.BBGeo.set({ region: geoState, source: 'user' }, { silent: true });
    else { sessionStorage.setItem('bb_geo_state', geoState); sessionStorage.removeItem('bb_geo_city'); sessionStorage.removeItem('bb_geo_city_ok'); }
    // Canada now gets the same city upgrade the USA store had: the postal
    // dataset is a separate lazily-fetched asset, and stays silent on failure.
    if (window.BBGeo) window.BBGeo.resolveCity(postal, geoState, function (hit) {
      if (hit && hit.city) { geoCity = hit.city; try { refreshFromCart(); } catch (e) {} }
    });

    ga4Event('bb_estimator_postal', { postal: postal, province: province, zone: geoZone });
      try { document.dispatchEvent(new CustomEvent('bb:geo-change', { detail: { state: geoState, zone: geoZone } })); } catch (e) {}

    var zipEls = document.querySelectorAll('[id^="bb-ship-zip-"]');
    for (var i = 0; i < zipEls.length; i++) zipEls[i].style.display = 'none';

    if (ctx === 'cart' || ctx === 'cartpage') {
      var cartEl = document.getElementById('bb-ship-est-' + ctx);
      if (cartEl) {
        var cartTotal = parseInt(cartEl.dataset.cartTotal || '0', 10);
        renderElement(ctx, cartTotal);
      }
    } else {
      var productEl = document.getElementById('bb-ship-est-product');
      if (productEl) {
        renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
      }
    }
  }

  var observer = new MutationObserver(function() {
    var cartEl = document.getElementById('bb-ship-est-cart');
    if (cartEl && !cartEl.dataset.rendered) {
      cartEl.dataset.rendered = '1';
      if (geoState) refreshFromCart(); else showZipFallback();
      bindPdpVariantListener();
    }
    var productEl = document.getElementById('bb-ship-est-product');
    if (productEl && !productEl.dataset.rendered) {
      productEl.dataset.rendered = '1';
      bindPdpVariantListener();
      if (geoState) {
        var total = parseInt(productEl.dataset.cartTotal || '0', 10);
        renderElement('product', total);
      }
    }
    var zipBtns = document.querySelectorAll('[id^="bb-ship-zip-btn-"]');
    for (var i = 0; i < zipBtns.length; i++) {
      if (!zipBtns[i].dataset.bound) {
        zipBtns[i].dataset.bound = '1';
        zipBtns[i].addEventListener('click', handleZipClick);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // "change" link — reset geo and show postal code form
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-bb-reset]');
    if (link) { e.preventDefault(); resetGeo(); }
  });

  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add') || url.includes('/cart/clear'))) {
      if (url.includes('/cart/add') && geoZone) {
        ga4Event('bb_atc_with_estimator', { zone: geoZone, province: geoState });
      }
      result.then(function() { scheduleRefresh(); });
    }
    return result;
  };
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._bbUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._bbUrl && (xhr._bbUrl.includes('/cart/change') || xhr._bbUrl.includes('/cart/update') || xhr._bbUrl.includes('/cart/add') || xhr._bbUrl.includes('/cart/clear'))) {
      if (xhr._bbUrl.includes('/cart/add') && geoZone) {
        ga4Event('bb_atc_with_estimator', { zone: geoZone, province: geoState });
      }
      xhr.addEventListener('load', function() { scheduleRefresh(); });
    }
    return origXHRSend.apply(this, arguments);
  };

  // Init
  resolveGeo(function() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          var qty = 0;
          for (var i = 0; i < cart.items.length; i++) qty += cart.items[i].quantity;
          if (qty > 0) avgItemPrice = Math.round(cart.total_price / qty);
        }
        try {
          window.__bbCartCraneKnown = true;
          window.__bbCartItemCount = (cart.items || []).length;
          window.__bbCartLanes = bbCartLanes(cart.items);
          window.__bbCartCrane = bbCartHasCrane(cart.items);
        } catch (_e) {}
        if (!avgItemPrice) {
          var priceEl = document.querySelector('[data-product-price], .product__price .money, .product-single__price .money');
          if (priceEl) {
            var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
            var price = parseFloat(priceText);
            if (price > 0) avgItemPrice = Math.round(price * 100);
          }
        }
        var productEl = document.getElementById('bb-ship-est-product');
        if (productEl) {
          var anchor = document.querySelector('product-form');
          if (anchor) anchor.after(productEl);
          renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
        }
        var cartEl = document.getElementById('bb-ship-est-cart');
        var cartPageEl = document.getElementById('bb-ship-est-cartpage');
        if (cartEl || cartPageEl) renderAll(bbFreightCents(cart)); bbApplySampleOnly(cart);
      })
      .catch(function() {
        var productEl = document.getElementById('bb-ship-est-product');
        if (productEl) renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
        var cpEl = document.getElementById('bb-ship-est-cartpage');
        if (cpEl) renderElement('cartpage', parseInt(cpEl.dataset.cartTotal || '0', 10));
      });
  });

  // Live preview from the fence calculator. The calc snippet dispatches
  // bb:calc-quote with { totalCents, panelQty, ... }. We add the planned calc
  // total to the user's real cart total so the FREE-shipping progress bar +
  // current tier reflect what the customer is about to add. The real cart
  // refresh (via PerformanceObserver / cart:updated) still wins after ATC.
  var _lastRealCartTotal = 0;
  document.addEventListener('cart:updated', function () {
    // BB_CART_LIVE_FIX: snapshot for calc previews AND re-render. Previously this only
    // updated the snapshot, so a quantity edit on the cart never repainted the hero.
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      _lastRealCartTotal = (c && c.total_price) || 0;
      renderAll(_lastRealCartTotal);
    }).catch(function(){});
    scheduleRefresh();
  });
  // Capture once on init too
  fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
    _lastRealCartTotal = (c && c.total_price) || 0;
  }).catch(function(){});

  // SO state comes from bb-mesh-swap (single source of truth).
  /* ⭐ LIVE CART on the CA store, matching the USA fix (owner 2026-10-26: "slider doesn't update
     without a refresh"). refreshFromCart() already existed; nothing called it on an add, a remove
     or a quantity change.
     ⛔ This file does NOT have bbCalcExtraCents — the USA-shaped patch anchored on it and no-opped
        here, which is how Canada was left a reload behind. Anchored on CA's own listener block. */
  (function () {
    var _bbLastTotalCA = null;
    function _bbCartRefreshCA() {
      try {
        fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (!c || typeof c.total_price !== 'number') return;
            if (c.total_price === _bbLastTotalCA) return;
            _bbLastTotalCA = c.total_price;
            try { refreshFromCart(); } catch (_) {}
          })
          .catch(function () {});
      } catch (e) {}
    }
    try {
      if (!window.__bbEstCartHookCA) {
        window.__bbEstCartHookCA = 1;
        var _oF = window.fetch;
        if (typeof _oF === 'function') {
          window.fetch = function () {
            var _a = arguments, _u = '';
            try { _u = (typeof _a[0] === 'string') ? _a[0] : ((_a[0] && _a[0].url) || ''); } catch (e) {}
            var _p = _oF.apply(this, _a);
            try {
              if (/\/cart\/(add|change|update|clear)/i.test(_u)) _p.then(function () { setTimeout(_bbCartRefreshCA, 180); }, function () {});
            } catch (e) {}
            return _p;
          };
        }
      }
    } catch (e) {}
    try {
      var _evs = ['bb:cart-updated', 'cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'];
      for (var _i = 0; _i < _evs.length; _i++) document.addEventListener(_evs[_i], function () { setTimeout(_bbCartRefreshCA, 100); });
      window.addEventListener('focus', _bbCartRefreshCA);
      window.addEventListener('pageshow', _bbCartRefreshCA);
    } catch (e) {}
  })();

  var _soStateDeb = null;
  document.addEventListener('bb:so-state', function (e) {
    if (!e || !e.detail) return;
    var so = !!e.detail.isSO;
    if (so === hasSpecialOrderInCart) return;
    hasSpecialOrderInCart = so;
    clearTimeout(_soStateDeb);
    _soStateDeb = setTimeout(function () {
      try { refreshFromCart(); } catch (err) {}   // BB_CART_LIVE_FIX: live, not snapshot
    }, 60);
  });

  var _calcRenderDeb = null;
  document.addEventListener('bb:calc-quote', function (e) {
    if (!e || !e.detail) return;
    var calcCents = Number(e.detail.totalCents) || 0;
    clearTimeout(_calcRenderDeb);
    _calcRenderDeb = setTimeout(function () {
      // BB_CART_LIVE_FIX: read the CURRENT cart, then layer the calc preview on top.
      try {
        fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
          var real = (c && c.total_price) || 0;
          _lastRealCartTotal = real;
          renderAll(real + ((real > 0) ? 0 : calcCents));
        }).catch(function () { renderAll(_lastRealCartTotal + ((_lastRealCartTotal > 0) ? 0 : calcCents)); });
      } catch (err) {}
    }, 120);
  });

  // A ZIP/postal entered in the announcement bar writes bb_geo_state and fires bb:geo-change.
  // Geo is resolved ONCE at init into geoState/geoCity/geoZone, so without this the PDP hero
  // and the slide-cart keep showing the previous location and price until a page reload.
  // Handles CLEAR as well as set — "change" empties the stored location.
  document.addEventListener('bb:geo-change', function () {
    try {
      var _g = window.BBGeo ? window.BBGeo.get() : null;
      var st = _g ? _g.state : sessionStorage.getItem('bb_geo_state');
      var cty = _g ? (_g.city || '') : '';
      if (st && ZONES[st]) { geoState = st; geoCity = cty; geoZone = ZONES[st]; }
      else { geoState = null; geoCity = null; geoZone = null; }
      refreshFromCart();
    } catch (e) {}
  });
})();



/* ⭐ COLLAPSED TWO-TRUCK FLAG (owner 2026-10-26: "has to be collapsed").
   ⛔ Delegated, not inline: the estimator re-renders this card on every cart and geo change, so a
      handler bound to the button would die with the node. Attached once, at document level. */
(function () {
  if (window.__bbMixToggle) return;
  window.__bbMixToggle = 1;
  document.addEventListener('click', function (e) {
    var t = (e.target && e.target.closest) ? e.target.closest('[data-bb-mixtoggle]') : null;
    if (!t) return;
    e.preventDefault();
    var b = t.nextElementSibling;
    if (!b) return;
    var o = b.style.display === 'none';
    b.style.display = o ? 'block' : 'none';
    t.setAttribute('aria-expanded', o ? 'true' : 'false');
    var c = t.querySelector('[data-bb-mixcaret2]');
    if (c) c.textContent = o ? '▴' : '▾';
  });
})();




